<p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>

<div class="contract-detail-container p-6 w-full">
  <!-- Breadcrumb -->
  <div class="mb-4">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/professionals-dashboard', ariaLabel: 'Home' }" [attr.aria-label]="'Breadcrumb navigation'"
    >
    </p-breadcrumb>
  </div>

  <!-- Page Header -->
  <div class="page-header mb-4">
    <div class="header-content">
      <div class="header-left">
        <button
          pButton
          icon="pi pi-arrow-left"
          class="p-button-text p-button-plain header-back-btn"
          (click)="goBack()"
          aria-label="Torna al registro contratti"
        ></button>
        <div>
          <h1 class="text-3xl font-bold m-0" style="color: #00125b">
            {{ getContractNumber() || 'Dettaglio Contratto' }}
          </h1>
          <p class="professional-info">
            @if (isSelectedEntityProfessional()) {
              <strong>{{ professionalBusinessName() }}</strong><br>
                ID: {{ professionalId() }}

              @if (professionalCategory()) {
                  &nbsp;·&nbsp;{{ professionalCategory() }}
              }
            } @else if (supplierId()) {
              @if (supplierDisplayName()) {
                <strong>{{ supplierDisplayName() }}</strong><br>
              }
              ID: {{ supplierId() }}
            }
          </p>
          <p class="text-color-secondary mt-2 mb-0">
            @if (contract()?.id) {
              <span class="font-medium">ID: {{ contract()!.id }}</span>
              <span class="mx-2">•</span>
            }
            {{ getContractSubject() }}
          </p>
        </div>
      </div>
    </div>
  </div>

  @if (isLoading()) {
    <div
      class="flex align-items-center justify-content-center flex-column"
      style="min-height: 400px"
      role="status"
      aria-live="polite"
    >
      <p-progress-spinner [attr.aria-label]="'Caricamento dettagli contratto in corso'"></p-progress-spinner>
      <p class="mt-3 text-600">Caricamento dettagli contratto in corso...</p>
    </div>
  } @else if (contract()) {
    @if (contract()?.generalInfo) {
    <!-- ================= SECTION 1: INFORMAZIONI GENERALI ================= -->
    <section
      appCollapsibleSection
      sectionExpanded
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="info-generali-heading"
    >
      <div
        class="flex align-items-center justify-content-between mb-4 pb-3 border-bottom-1 border-200"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-file text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="info-generali-heading" class="text-xl font-semibold m-0">
            Informazioni Generali del Contratto
          </h2>
        </div>
        <div class="flex align-items-center gap-2">
          <p-tag [value]="getStatus()" [severity]="getStatusSeverity(getRawStatus())"></p-tag>
          <app-section-collapse-toggle sectionName="Informazioni Generali del Contratto"></app-section-collapse-toggle>
        </div>
      </div>

      <div class="form-grid">
        <div class="item">
          <label for="contract-id">ID Contratto</label>
          <input
            id="contract-id"
            pInputText
            [value]="contractId()"
            [disabled]="true"
            class="w-full"
          />
        </div>
        
        <!-- ID e Categoria Fiduciario (solo se professionalId presente) -->
        @if (professionalId()) {
          <div class="item">
            <label for="professional-id">ID Fiduciario</label>
            <input
              id="professional-id"
              pInputText
              [value]="professionalId()"
              [disabled]="true"
              class="w-full"
            />
          </div>
          
          @if (professionalCategory()) {
            <div class="item">
              <label for="professional-category">Categoria Fiduciario</label>
              <input
                id="professional-category"
                pInputText
                [value]="professionalCategory()"
                [disabled]="true"
                class="w-full"
              />
            </div>
          }
        }
        
        <div class="item">
          <label for="contract-type"
            >Tipo Contratto <span class="text-red-500" aria-hidden="true">*</span></label
          >
          @if (isEditModeGenerali()) {
            <p-select
              id="contract-type"
              [(ngModel)]="contract()!.generalInfo!.contractType"
              [options]="contractTypeOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona tipo"
              class="w-full" [attr.aria-label]="'Tipo contratto'"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="contract-type-view"
              pInputText
              [value]="
                getDropdownLabel(contractTypeOptions(), contract()?.generalInfo?.contractType)
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="service-type"
              >Tipologia Servizio - Commodity
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeGenerali()) {
            <p-select
              id="service-type"
              [(ngModel)]="contract()!.generalInfo!.serviceType"
              [options]="serviceTypeOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona tipologia"
              class="w-full" [attr.aria-label]="'Tipologia servizio commodity'"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="service-type-view"
              pInputText
              [value]="getDropdownLabel(serviceTypeOptions(), contract()?.generalInfo?.serviceType)"
              [disabled]="true"
              class="w-full"
            />
          }
          </div>
        }

          <div class="item full-width">
            <label for="entities"
              >Entity Coinvolte <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeGenerali()) {
              <div class="flex flex-column gap-3">
                @for (entity of getInvolvedEntities(); track $index) {
                  <div class="surface-50 border-round p-4">
                    <div class="flex justify-content-between align-items-center mb-3">
                      <h4 class="text-md font-semibold m-0">Entity Coinvolta #{{ $index + 1 }}</h4>
                      <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        size="small"
                        [text]="true"
                        (onClick)="removeInvolvedEntity($index)"
                        [disabled]="getInvolvedEntities().length === 1"
                      ></p-button>
                    </div>

                    <div class="grid">
                      <div class="field col-12 md:col-4">
                        <label [for]="'entities-' + $index">Denominazione Entità</label>
                        <p-select
                          [id]="'entities-' + $index"
                          [(ngModel)]="contract()!.generalInfo!.involvedEntities[$index].entityCode"
                          [options]="getAvailableInvolvedEntityOptions($index)"
                          optionLabel="entityDescription"
                          optionValue="entityCode"
                          placeholder="Seleziona entità"
                          (onChange)="onInvolvedEntityChange($index)"
                          class="w-full"
                        ></p-select>
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'signatory-name-' + $index">
                          Firmato da ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'signatory-name-' + $index"
                          pInputText
                          [(ngModel)]="contract()!.generalInfo!.involvedEntities[$index].signatoryName"
                          class="w-full"
                        />
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'signatory-role-' + $index">
                          Ruolo Firmatario ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'signatory-role-' + $index"
                          pInputText
                          [(ngModel)]="contract()!.generalInfo!.involvedEntities[$index].signatoryRole"
                          class="w-full"
                        />
                      </div>
                    </div>
                  </div>
                }

                <div class="flex justify-content-end">
                  <p-button
                    label="Aggiungi Entity Coinvolta"
                    icon="pi pi-plus"
                    size="small"
                    (onClick)="addInvolvedEntity()"
                    [disabled]="!canAddMoreInvolvedEntities()"
                  ></p-button>
                </div>
              </div>
            } @else {
              <div class="flex flex-column gap-3">
                @for (entity of getInvolvedEntities(); track $index) {
                  <div class="surface-50 border-round p-4">
                    <div class="grid">
                      <div class="field col-12 md:col-4">
                        <label [for]="'entities-view-' + $index">Denominazione Entità</label>
                        <input
                          [id]="'entities-view-' + $index"
                          pInputText
                          [value]="getInvolvedEntityLabel(entity.entityCode)"
                          [disabled]="true"
                          class="w-full"
                        />
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'signatory-name-view-' + $index">
                          Firmato da ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'signatory-name-view-' + $index"
                          pInputText
                          [value]="entity.signatoryName || '-'"
                          [disabled]="true"
                          class="w-full"
                        />
                      </div>

                      <div class="field col-12 md:col-4">
                        <label [for]="'signatory-role-view-' + $index">
                          Ruolo Firmatario ({{ getInvolvedEntityLabel(entity.entityCode) }})
                        </label>
                        <input
                          [id]="'signatory-role-view-' + $index"
                          pInputText
                          [value]="entity.signatoryRole || '-'"
                          [disabled]="true"
                          class="w-full"
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>

        @if (!isContractProfessional()) {
          <div class="item full-width">
            <label for="contract-object"
            >Oggetto del Contratto <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <textarea
            id="contract-object"
            pInputTextarea
            [(ngModel)]="contract()!.generalInfo!.contractSubject"
            [disabled]="!isEditModeGenerali()"
            rows="3"
            class="w-full"
            [attr.aria-required]="true"
          ></textarea>
          </div>
        }

        @if (!isContractProfessional()) {
          <div class="item">
            <label for="externalized-activity"
            >Attività Esternalizzata <span class="text-red-500" aria-hidden="true">*</span></label
          >
          @if (isEditModeGenerali()) {
            <p-select
              id="outsourced-activity"
              [(ngModel)]="contract()!.generalInfo!.outsourcedActivity"
              [options]="externalizedActivityOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona attività"
              class="w-full"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="outsourced-activity-view"
              pInputText
              [value]="
                getDropdownLabel(
                  externalizedActivityOptions(),
                  contract()?.generalInfo?.outsourcedActivity
                )
              "
              [disabled]="true"
              class="w-full"
            />
          }
          </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="owner-sla"
              >Owner SLA & KPI <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
            id="owner-sla"
            pInputText
            [(ngModel)]="contract()!.generalInfo!.slaKpiPerson"
            [disabled]="!isEditModeGenerali()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        }
        <div class="item">
          <label for="start-date"
            >Data Inizio <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <p-datepicker
            id="start-date"
            [(ngModel)]="contract()!.generalInfo!.startDate"
            [disabled]="!isEditModeGenerali()"
            dateFormat="dd/mm/yy"
            iconDisplay="input"
            [inputStyle]="{ width: '100%' }"
            [attr.aria-required]="true"
          ></p-datepicker>
        </div>

        <div class="item">
          <label for="end-date"
            >Data Fine <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <p-datepicker
            id="end-date"
            [(ngModel)]="contract()!.generalInfo!.endDate"
            [disabled]="!isEditModeGenerali()"
            [minDate]="$any(contract()?.generalInfo?.startDate)"
            dateFormat="dd/mm/yy"
            iconDisplay="input"
            class="w-full"
            [attr.aria-required]="true"
          ></p-datepicker>
        </div>
        <div class="item">
          <label for="tacit-renewal"
            >Rinnovo Tacito <span class="text-red-500" aria-hidden="true">*</span></label
          >
          @if (isEditModeGenerali()) {
            <p-select
              id="tacit-renewal"
              [(ngModel)]="contract()!.generalInfo!.automaticRenewal"
              [options]="automaticRenewalOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona"
              class="w-full"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="tacit-renewal-view"
              pInputText
              [value]="
                getDropdownLabel(
                  automaticRenewalOptions(),
                  contract()?.generalInfo?.automaticRenewal
                )
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        @if (isNumberOfRenewalsRequired()) {
          <div class="item">
            <label for="number-of-renewals">
              Numero rinnovi <span class="text-red-500" aria-hidden="true">*</span>
            </label>
            <p-input-number
              inputId="number-of-renewals"
              [(ngModel)]="contract()!.generalInfo!.numberOfRenewals"
              [disabled]="!isEditModeGenerali()"
              [min]="2"
              [maxFractionDigits]="0"
              [useGrouping]="false"
              [required]="true"
              class="w-full"
              [attr.aria-required]="true"
              [attr.aria-invalid]="isEditModeGenerali() && isNumberOfRenewalsInvalid()"
              [attr.aria-describedby]="isEditModeGenerali() && isNumberOfRenewalsInvalid() ? 'number-of-renewals-error' : null"
            />
            @if (isEditModeGenerali() && isNumberOfRenewalsInvalid()) {
              <small id="number-of-renewals-error" class="text-red-500" role="alert">
                Inserisci un numero intero superiore a 1.
              </small>
            }
          </div>
        }
        <div class="item">
          <label for="termination-notice-days"
            >Preavviso Disdetta (giorni)
            <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <p-input-number
            id="termination-notice-days"
            [(ngModel)]="contract()!.generalInfo!.terminationNoticeDays"
            [disabled]="!isEditModeGenerali()"
            class="w-full"
            [attr.aria-required]="true"
          ></p-input-number>
        </div>
        @if (
          contract()?.generalInfo?.automaticRenewal === 'YES' ||
          contract()?.generalInfo?.automaticRenewal === 'ANNUAL'
        ) {
          <div class="item">
            <label for="renewal-notice-days"
              >Preavviso per Rinnovo Contratto (giorni)
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <p-input-number
              id="renewal-notice-days"
              [(ngModel)]="contract()!.generalInfo!.renewalNoticeDays"
              [disabled]="!isEditModeGenerali()"
              [min]="0"
              class="w-full"
              [attr.aria-required]="true"
            ></p-input-number>
          </div>
        }
        <div class="item">
          <label for="synergies"
            >Sinergie <span class="text-red-500" aria-hidden="true">*</span></label
          >
          @if (isEditModeGenerali()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Sinergie" aria-required="true">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="synergies"
                  inputId="synergies-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.generalInfo!.synergies"
                ></p-radiobutton>
                <label for="synergies-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="synergies"
                  inputId="synergies-no"
                  [value]="false"
                  [(ngModel)]="contract()!.generalInfo!.synergies"
                ></p-radiobutton>
                <label for="synergies-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.generalInfo?.synergies ? 'Sì' : 'No'"
                [severity]="contract()?.generalInfo?.synergies ? 'success' : 'secondary'"
              ></p-tag>
            </div>
          }
        </div>
        @if (contract()?.generalInfo?.synergies) {
          <div class="item">
            <label for="synergies-companies"
              >Compagnie con Sinergie <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeGenerali()) {
              <p-multiselect
                id="synergies-companies"
                [(ngModel)]="contract()!.generalInfo!.synergiesCompanies"
                [options]="synergiesCompaniesOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona compagnie"
                display="chip"
                class="w-full"
                [attr.aria-required]="true"
              ></p-multiselect>
            } @else {
              <input
                id="synergies-companies-view"
                pInputText
                [value]="
                  getMultiDropdownLabels(
                    synergiesCompaniesOptions(),
                    contract()?.generalInfo?.synergiesCompanies
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="sc-involved">SC Coinvolto</label>
            <input
              id="sc-involved"
              pInputText
              [(ngModel)]="contract()!.generalInfo!.involvedSc"
              [disabled]="!isEditModeGenerali()"
              class="w-full"
            />
          </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="supplier-type"
              >Tipologia di Fornitore <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeGenerali()) {
              <p-select
                id="supplier-type"
                [(ngModel)]="contract()!.generalInfo!.supplierType"
                [options]="supplierTypeOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona tipologia"
                class="w-full"
                [attr.aria-required]="true"
              ></p-select>
            } @else {
              <input
                id="supplier-type-view"
                pInputText
                [value]="
                  getDropdownLabel(supplierTypeOptions(), contract()?.generalInfo?.supplierType)
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>
        }
        
        <!-- Campi specifici Professional -->
        @if (isContractProfessional()) {
          <div class="item">
            <label for="management-tools">Tool Gestionali</label>
            @if (isEditModeGenerali()) {
              <p-multiselect
                id="management-tools"
                [(ngModel)]="contract()!.generalInfo!.managementTools"
                [options]="toolGestionaliOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona tool"
                display="chip"
                class="w-full"
              ></p-multiselect>
            } @else {
              <input
                id="management-tools-view"
                pInputText
                [value]="
                  getMultiDropdownLabels(toolGestionaliOptions(), contract()?.generalInfo?.managementTools)
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>

          <div class="item">
            <label for="network">Network</label>
            @if (isEditModeGenerali()) {
              <p-multiselect
                id="network"
                [(ngModel)]="contract()!.generalInfo!.network"
                [options]="networkOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona network"
                display="chip"
                [required]="true"
                [attr.aria-required]="true"
                class="w-full"
              ></p-multiselect>
            } @else {
              <input
                id="network-view"
                pInputText
                [value]="
                  getMultiDropdownLabels(networkOptions(), contract()?.generalInfo?.network)
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>
        }
      </div>

      <!-- Button section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (isEditModeGenerali()) {
          <p-button
            label="Annulla"
            icon="pi pi-times"
            [outlined]="true"
            size="small"
            (onClick)="toggleEditGenerali()" [attr.aria-label]="'Annulla modifiche informazioni generali'"
            pTooltip="Annulla modifiche"
            tooltipPosition="top"
            title="Annulla modifiche"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (onClick)="saveSection('generali')" [attr.aria-label]="'Salva modifiche informazioni generali'"
            pTooltip="Salva modifiche"
            tooltipPosition="top"
            title="Salva modifiche"
          ></p-button>
        } @else if (isContractEditable()) {
          <p-button
            label="Modifica"
            icon="pi pi-pencil"
            [outlined]="true"
            size="small"
            [disabled]="hasAnySectionInEditMode()"
            (onClick)="toggleEditGenerali()"
            [ariaLabel]="
              hasAnySectionInEditMode()
                ? 'Modifica informazioni generali - disabilitato: completa o annulla le modifiche alla sezione corrente'
                : 'Modifica informazioni generali'
            "
            [pTooltip]="
              hasAnySectionInEditMode()
                ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                : 'Modifica sezione'
            "
            tooltipPosition="top"
          ></p-button>
        }
      </div>
    </section>
    }

    <!-- ================= SECTION 2: CONTRATTO QUADRO ================= -->
    <section
      appCollapsibleSection
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="contratto-quadro-heading"
      [hidden]="isContractProfessional()"
    >
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-briefcase text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 id="contratto-quadro-heading" class="text-xl font-semibold m-0">Contratto Quadro</h2>
        <app-section-collapse-toggle sectionName="Contratto Quadro"></app-section-collapse-toggle>
      </div>

      <div class="form-grid">
        <div class="item">
          <label for="framework-agreement">Accordo Quadro</label>
          @if (isEditModeQuadro()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Accordo Quadro">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="frameworkAgreement"
                  inputId="framework-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.frameworkAgreement!.frameworkAgreement"
                ></p-radiobutton>
                <label for="framework-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="frameworkAgreement"
                  inputId="framework-no"
                  [value]="false"
                  [(ngModel)]="contract()!.frameworkAgreement!.frameworkAgreement"
                ></p-radiobutton>
                <label for="framework-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.frameworkAgreement?.frameworkAgreement ? 'Sì' : 'No'"
                [severity]="
                  contract()?.frameworkAgreement?.frameworkAgreement ? 'success' : 'secondary'
                "
              ></p-tag>
            </div>
          }
        </div>
        @if (contract()?.frameworkAgreement?.frameworkAgreement) {
          <div class="item">
            <label for="framework-start"
              >Inizio Accordo Quadro <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <p-datepicker
              id="framework-start"
              [(ngModel)]="contract()!.frameworkAgreement!.frameworkStartDate"
              [disabled]="!isEditModeQuadro()"
              dateFormat="dd/mm/yy"
              iconDisplay="input"
              class="w-full"
              [attr.aria-required]="true"
            ></p-datepicker>
          </div>
          <div class="item">
            <label for="framework-end"
              >Fine Accordo Quadro <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <p-datepicker
              id="framework-end"
              [(ngModel)]="contract()!.frameworkAgreement!.frameworkEndDate"
              [disabled]="!isEditModeQuadro()"
              [minDate]="$any(contract()?.frameworkAgreement?.frameworkStartDate)"
              dateFormat="dd/mm/yy"
              iconDisplay="input"
              class="w-full"
              [attr.aria-required]="true"
            ></p-datepicker>
          </div>

          <div class="item">
            <label for="framework-tacit"
              >Rinnovo Tacito <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeQuadro()) {
              <p-select
                id="framework-tacit"
                [(ngModel)]="contract()!.frameworkAgreement!.automaticRenewal"
                [options]="automaticRenewalOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona"
                class="w-full"
                [attr.aria-required]="true"
              ></p-select>
            } @else {
              <input
                id="framework-tacit-view"
                pInputText
                [value]="
                  getDropdownLabel(
                    automaticRenewalOptions(),
                    contract()?.frameworkAgreement?.automaticRenewal
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>
          <div class="item">
            <label for="framework-renewal-notice-days"
              >Preavviso per il Rinnovo
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeQuadro()) {
              <p-select
                id="framework-renewal-notice-days"
                [(ngModel)]="contract()!.frameworkAgreement!.renewalNoticeDays"
                [options]="renewalNoticeOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona"
                class="w-full"
                [attr.aria-required]="true"
              ></p-select>
            } @else {
              <input
                id="framework-renewal-notice-days-view"
                pInputText
                [value]="
                  getDropdownLabel(
                    renewalNoticeOptions(),
                    contract()?.frameworkAgreement?.renewalNoticeDays
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>
        }
      </div>

      <!-- Button section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (isEditModeQuadro()) {
          <p-button
            label="Annulla"
            icon="pi pi-times"
            [outlined]="true"
            size="small"
            (onClick)="toggleEditQuadro()" [attr.aria-label]="'Annulla modifiche contratto quadro'"
            pTooltip="Annulla modifiche"
            tooltipPosition="top"
            title="Annulla modifiche"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (onClick)="saveSection('quadro')" [attr.aria-label]="'Salva modifiche contratto quadro'"
            pTooltip="Salva modifiche"
            tooltipPosition="top"
            title="Salva modifiche"
          ></p-button>
        } @else if (isContractEditable()) {
          <p-button
            label="Modifica"
            icon="pi pi-pencil"
            [outlined]="true"
            size="small"
            [disabled]="hasAnySectionInEditMode()"
            (onClick)="toggleEditQuadro()"
            [ariaLabel]="
              hasAnySectionInEditMode()
                ? 'Modifica contratto quadro - disabilitato: completa o annulla le modifiche alla sezione corrente'
                : 'Modifica contratto quadro'
            "
            [pTooltip]="
              hasAnySectionInEditMode()
                ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                : 'Modifica sezione'
            "
            tooltipPosition="top"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= SECTION 3: ECONOMICS ================= -->
    <section
      appCollapsibleSection
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="economics-heading"
    >
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-euro text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 id="economics-heading" class="text-xl font-semibold m-0">Economics</h2>
        <app-section-collapse-toggle sectionName="Economics"></app-section-collapse-toggle>
      </div>

      <div class="form-grid">
        <div class="item">
          <label for="expected-fee">Corrispettivo Previsto</label>
          @if (isEditModeEconomics()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Corrispettivo Previsto">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="expectedFee"
                  inputId="expected-fee-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.economics!.expectedFee"
                ></p-radiobutton>
                <label for="expected-fee-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="expectedFee"
                  inputId="expected-fee-no"
                  [value]="false"
                  [(ngModel)]="contract()!.economics!.expectedFee"
                ></p-radiobutton>
                <label for="expected-fee-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.economics?.expectedFee ? 'Sì' : 'No'"
                [severity]="contract()?.economics?.expectedFee ? 'success' : 'secondary'"
              ></p-tag>
            </div>
          }
        </div>
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="rebates">Rebates</label>
            @if (isEditModeEconomics()) {
              <div class="flex gap-4" role="radiogroup" aria-label="Rebates">
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="rebates"
                    inputId="rebates-yes"
                    [value]="true"
                    [(ngModel)]="contract()!.economics!.rebates"
                  ></p-radiobutton>
                  <label for="rebates-yes" class="ml-2">Sì</label>
                </div>
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="rebates"
                    inputId="rebates-no"
                    [value]="false"
                    [(ngModel)]="contract()!.economics!.rebates"
                  ></p-radiobutton>
                  <label for="rebates-no" class="ml-2">No</label>
                </div>
              </div>
            } @else {
              <div class="flex align-items-center gap-2">
                <p-tag
                  [value]="contract()?.economics?.rebates ? 'Sì' : 'No'"
                  [severity]="contract()?.economics?.rebates ? 'success' : 'secondary'"
                ></p-tag>
              </div>
            }
          </div>
          @if (contract()?.economics?.rebates) {
            <div class="item full-width">
              <label for="rebates-notes">Note Rebates</label>
              <textarea
                id="rebates-notes"
                pInputTextarea
                [(ngModel)]="contract()!.economics!.rebatesNote"
                [disabled]="!isEditModeEconomics()"
                rows="2"
                class="w-full"
              ></textarea>
            </div>
          }
        }

        @if (!isContractProfessional()) {
          <div class="item">
          <label for="invoice-sol">Fattura Caricata su SOL</label>
          @if (isEditModeEconomics()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Fattura Caricata su SOL">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="invoiceOnSol"
                  inputId="invoice-sol-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.economics!.invoiceOnSol"
                ></p-radiobutton>
                <label for="invoice-sol-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="invoiceOnSol"
                  inputId="invoice-sol-no"
                  [value]="false"
                  [(ngModel)]="contract()!.economics!.invoiceOnSol"
                ></p-radiobutton>
                <label for="invoice-sol-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.economics?.invoiceOnSol ? 'Sì' : 'No'"
                [severity]="contract()?.economics?.invoiceOnSol ? 'success' : 'secondary'"
              ></p-tag>
            </div>
          }
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="technical-account">Se Negativo, Conto Tecnico</label>
          @if (isEditModeEconomics()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Se Negativo, Conto Tecnico">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="technicalAccount"
                  inputId="technical-account-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.economics!.technicalAccount"
                ></p-radiobutton>
                <label for="technical-account-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="technicalAccount"
                  inputId="technical-account-no"
                  [value]="false"
                  [(ngModel)]="contract()!.economics!.technicalAccount"
                ></p-radiobutton>
                <label for="technical-account-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.economics?.technicalAccount ? 'Sì' : 'No'"
                [severity]="contract()?.economics?.technicalAccount ? 'success' : 'secondary'"
              ></p-tag>
            </div>
          }
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="distribution-matrix"
              >Tipologia/Matrice Ripartizione
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
          @if (isEditModeEconomics()) {
            <p-select
              id="distribution-matrix"
              [(ngModel)]="contract()!.economics!.allocationMatrix"
              [options]="distributionTypeOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona"
              class="w-full"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="distribution-matrix-view"
              pInputText
              [value]="
                getDropdownLabel(distributionTypeOptions(), contract()?.economics?.allocationMatrix)
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="expense-account"
              >Conto Spese <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="expense-account"
              pInputText
              [(ngModel)]="contract()!.economics!.expenseAccount"
              [disabled]="!isEditModeEconomics()"
              class="w-full"
              [attr.aria-required]="true"
            />
          </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
          <label for="currency"
            >Valuta <span class="text-red-500" aria-hidden="true">*</span></label
          >
          @if (isEditModeEconomics()) {
            <p-select
              id="currency"
              [(ngModel)]="contract()!.economics!.currency"
              [options]="currencyOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona valuta"
              class="w-full"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="currency-view"
              pInputText
              [value]="getDropdownLabel(currencyOptions(), contract()?.economics?.currency)"
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        <div class="item">
          <label for="contract-value">Valore Durata Contratto IVA Esclusa</label>
          <p-input-number
            id="contract-value"
            [(ngModel)]="contract()!.economics!.totalContractValue"
            [disabled]="!isEditModeEconomics()"
            mode="currency"
            [currency]="contract()?.economics?.currency || 'EUR'"
            currencyDisplay="symbol"
            locale="it-IT"
            class="w-full"
          ></p-input-number>
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
          <label for="annual-value">Valore Annuale IVA Esclusa</label>
          <p-input-number
            id="annual-value"
            [(ngModel)]="contract()!.economics!.annualValue"
            [disabled]="!isEditModeEconomics()"
            mode="currency"
            [currency]="contract()?.economics?.currency || 'EUR'"
            currencyDisplay="symbol"
            locale="it-IT"
            class="w-full"
          ></p-input-number>
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="invoice-frequency"
              >Periodicità Ricezione Fattura
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
          @if (isEditModeEconomics()) {
            <p-select
              id="invoice-frequency"
              [(ngModel)]="contract()!.economics!.invoiceFrequency"
              [options]="invoiceFrequencyOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona"
              class="w-full"
            ></p-select>
          } @else {
            <input
              id="invoice-frequency-view"
              pInputText
              [value]="
                getDropdownLabel(invoiceFrequencyOptions(), contract()?.economics?.invoiceFrequency)
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        }
      </div>

      <!-- Button section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (isEditModeEconomics()) {
          <p-button
            label="Annulla"
            icon="pi pi-times"
            [outlined]="true"
            size="small"
            (onClick)="toggleEditEconomics()" [attr.aria-label]="'Annulla modifiche economics'"
            pTooltip="Annulla modifiche"
            tooltipPosition="top"
            title="Annulla modifiche"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (onClick)="saveSection('economics')" [attr.aria-label]="'Salva modifiche economics'"
            pTooltip="Salva modifiche"
            tooltipPosition="top"
            title="Salva modifiche"
          ></p-button>
        } @else if (isContractEditable()) {
          <p-button
            label="Modifica"
            icon="pi pi-pencil"
            [outlined]="true"
            size="small"
            [disabled]="hasAnySectionInEditMode()"
            (onClick)="toggleEditEconomics()"
            [ariaLabel]="
              hasAnySectionInEditMode()
                ? 'Modifica economics - disabilitato: completa o annulla le modifiche alla sezione corrente'
                : 'Modifica economics'
            "
            [pTooltip]="
              hasAnySectionInEditMode()
                ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                : 'Modifica sezione'
            "
            tooltipPosition="top"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= SECTION 4: AMMINISTRAZIONE CONTRATTO ================= -->
    <section
      appCollapsibleSection
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="amministrazione-heading"
    >
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-users text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 id="amministrazione-heading" class="text-xl font-semibold m-0">
          Amministrazione Contratto
        </h2>
        <app-section-collapse-toggle sectionName="Amministrazione Contratto"></app-section-collapse-toggle>
      </div>

      <div class="form-grid">
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="managed-by"
              >Gestione Contratto in Carico a
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
          @if (isEditModeAmministrazione()) {
            <p-select
              id="managed-by"
              [(ngModel)]="contract()!.administration!.managingArea"
              [options]="managingAreaOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona"
              class="w-full"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="managed-by-view"
              pInputText
              [value]="
                getDropdownLabel(managingAreaOptions(), contract()?.administration?.managingArea)
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="claims-area"
              >Riferimento Area Claims <span class="text-red-500" aria-hidden="true">*</span></label
            >
          @if (isEditModeAmministrazione()) {
            <p-select
              id="claims-area"
              [(ngModel)]="contract()!.administration!.claimsAreaReference"
              [options]="claimsAreaOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona area"
              class="w-full"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="claims-area-view"
              pInputText
              [value]="
                getDropdownLabel(
                  claimsAreaOptions(),
                  contract()?.administration?.claimsAreaReference
                )
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="area-contact"
              >Eventuale Referente <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="area-contact"
              pInputText
              [(ngModel)]="contract()!.administration!.eventualReferent"
              [disabled]="!isEditModeAmministrazione()"
              class="w-full"
              [attr.aria-required]="true"
            />
          </div>
        }

        <div class="item">
          <label for="buyer">Buyer <span class="text-red-500" aria-hidden="true">*</span></label>
          <input
            id="buyer"
            pInputText
            [(ngModel)]="contract()!.administration!.buyer"
            [disabled]="!isEditModeAmministrazione()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        <div class="item">
          <label for="involved-structures"
            >Strutture Coinvolte <span class="text-red-500" aria-hidden="true">*</span></label
          >
          @if (isEditModeAmministrazione()) {
            <p-multiselect
              id="involved-structures"
              [(ngModel)]="contract()!.administration!.involvedStructures"
              [options]="involvedStructuresOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona strutture"
              display="chip"
              class="w-full"
              [attr.aria-required]="true"
            ></p-multiselect>
          } @else {
            <input
              id="involved-structures-view"
              pInputText
              [value]="
                getMultiDropdownLabels(
                  involvedStructuresOptions(),
                  contract()?.administration?.involvedStructures
                )
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="invoice-recipient"
              >Destinatario Fattura <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="invoice-recipient"
              pInputText
              [(ngModel)]="contract()!.administration!.invoiceRecipientEmail"
              [disabled]="!isEditModeAmministrazione()"
              class="w-full"
              [attr.aria-required]="true"
            />
          </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="control-owner"
              >Owner Controlli <span class="text-red-500" aria-hidden="true">*</span></label
            >
          <input
            id="control-owner"
            pInputText
            [(ngModel)]="contract()!.administration!.controlsOwner"
            [disabled]="!isEditModeAmministrazione()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="payment-authorizer"
              >Autorizzatore al Pagamento
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
          <input
            id="payment-authorizer"
            pInputText
            [(ngModel)]="contract()!.administration!.paymentAuthorizer"
            [disabled]="!isEditModeAmministrazione()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="documentation-ip">Documentazione Presso IP</label>
          @if (isEditModeAmministrazione()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Documentazione Presso IP">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="documentationAtIP"
                  inputId="documentation-ip-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.administration!.documentationAtIP"
                ></p-radiobutton>
                <label for="documentation-ip-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="documentationAtIP"
                  inputId="documentation-ip-no"
                  [value]="false"
                  [(ngModel)]="contract()!.administration!.documentationAtIP"
                ></p-radiobutton>
                <label for="documentation-ip-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.administration?.documentationAtIP ? 'Sì' : 'No'"
                [severity]="contract()?.administration?.documentationAtIP ? 'success' : 'secondary'"
              ></p-tag>
            </div>
          }
        </div>
        }

        @if (!isContractProfessional()) {
          <div class="item">
            <label for="supplier-signatory"
              >Contratto Firmato da (Firma Fornitore)
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
          <input
            id="supplier-signatory"
            pInputText
            [(ngModel)]="contract()!.administration!.supplierSignatory"
            [disabled]="!isEditModeAmministrazione()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        }
        @if (!isContractProfessional()) {
          <div class="item">
            <label for="supplier-role"
              >Ruolo Firma Fornitore <span class="text-red-500" aria-hidden="true">*</span></label
            >
          <input
            id="supplier-role"
            pInputText
            [(ngModel)]="contract()!.administration!.supplierSignatoryRole"
            [disabled]="!isEditModeAmministrazione()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        }
        @if (isContractProfessional()) {
          <div class="item">
            <label for="professional-signatory"
              >Contratto Firmato da (Fiduciario)
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
          <input
            id="professional-signatory"
            pInputText
            [(ngModel)]="contract()!.administration!.professionalSignatory"
            [disabled]="!isEditModeAmministrazione()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        }
        @if (isContractProfessional()) {
          <div class="item">
            <label for="professional-role"
              >Ruolo Firma Fiduciario <span class="text-red-500" aria-hidden="true">*</span></label
            >
          <input
            id="professional-role"
            pInputText
            [(ngModel)]="contract()!.administration!.professionalSignatoryRole"
            [disabled]="!isEditModeAmministrazione()"
            class="w-full"
            [attr.aria-required]="true"
          />
        </div>
        }
      </div>

      <!-- Button section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (isEditModeAmministrazione()) {
          <p-button
            label="Annulla"
            icon="pi pi-times"
            [outlined]="true"
            size="small"
            (onClick)="toggleEditAmministrazione()" [attr.aria-label]="'Annulla modifiche amministrazione'"
            pTooltip="Annulla modifiche"
            tooltipPosition="top"
            title="Annulla modifiche"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (onClick)="saveAmministrazione()" [attr.aria-label]="'Salva modifiche amministrazione'"
            pTooltip="Salva modifiche"
            tooltipPosition="top"
            title="Salva modifiche"
          ></p-button>
        } @else if (isAdministrationEditable()) {
          <p-button
            label="Modifica"
            icon="pi pi-pencil"
            [outlined]="true"
            size="small"
            [disabled]="hasAnySectionInEditMode()"
            (onClick)="toggleEditAmministrazione()"
            [ariaLabel]="
              hasAnySectionInEditMode()
                ? 'Modifica amministrazione - disabilitato: completa o annulla le modifiche alla sezione corrente'
                : 'Modifica amministrazione contratto'
            "
            [pTooltip]="
              hasAnySectionInEditMode()
                ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                : 'Modifica sezione'
            "
            tooltipPosition="top"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= SECTION 5: VRF - TRATTAMENTO DATI PERSONALI ================= -->
    <section
      appCollapsibleSection
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="vrf-heading"
      [hidden]="isContractProfessional()"
    >
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-shield text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 id="vrf-heading" class="text-xl font-semibold m-0">VRF - Trattamento Dati Personali</h2>
        <app-section-collapse-toggle sectionName="VRF - Trattamento Dati Personali"></app-section-collapse-toggle>
      </div>

      <div class="form-grid">
        <div class="item">
          <label for="vrf-use-case"
            >Caso d'uso VRF <span class="text-red-500" aria-hidden="true">*</span></label
          >
          @if (isEditModeVRF()) {
            <p-select
              id="vrf-use-case"
              [(ngModel)]="contract()!.dataProcessing!.vrfUseCase"
              [options]="vrfUseCaseOptions()"
              optionLabel="valueDescription"
              optionValue="valueKey"
              placeholder="Seleziona"
              class="w-full"
              [attr.aria-required]="true"
            ></p-select>
          } @else {
            <input
              id="vrf-use-case-view"
              pInputText
              [value]="
                getDropdownLabel(vrfUseCaseOptions(), contract()?.dataProcessing?.vrfUseCase)
              "
              [disabled]="true"
              class="w-full"
            />
          }
        </div>
        <div class="item">
          <label for="gdpr-data">Gestisce Dati ai Fini GDPR?</label>
          @if (isEditModeVRF()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Gestisce Dati ai Fini GDPR?">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="gdprDataProcessing"
                  inputId="gdpr-data-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.dataProcessing!.gdprDataProcessing"
                ></p-radiobutton>
                <label for="gdpr-data-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="gdprDataProcessing"
                  inputId="gdpr-data-no"
                  [value]="false"
                  [(ngModel)]="contract()!.dataProcessing!.gdprDataProcessing"
                ></p-radiobutton>
                <label for="gdpr-data-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.dataProcessing?.gdprDataProcessing ? 'Sì' : 'No'"
                [severity]="
                  contract()?.dataProcessing?.gdprDataProcessing ? 'success' : 'secondary'
                "
              ></p-tag>
            </div>
          }
        </div>
        @if (contract()?.dataProcessing?.gdprDataProcessing) {
          <div class="item">
            <label for="privacy-function"
              >Funzione Competente Materia Privacy
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="privacy-function"
              pInputText
              [(ngModel)]="contract()!.dataProcessing!.privacyResponsibleFunction"
              [disabled]="!isEditModeVRF()"
              class="w-full"
              placeholder="es. IP/Procurement"
              [attr.aria-required]="true"
            />
          </div>
        }

        <div class="item">
          <label for="extra-see">Invio Dati Extra SEE</label>
          @if (isEditModeVRF()) {
            <div class="flex gap-4" role="radiogroup" aria-label="Invio Dati Extra SEE">
              <div class="flex align-items-center">
                <p-radiobutton
                  name="dataTransferOutsideSee"
                  inputId="extra-see-yes"
                  [value]="true"
                  [(ngModel)]="contract()!.dataProcessing!.dataTransferOutsideSee"
                ></p-radiobutton>
                <label for="extra-see-yes" class="ml-2">Sì</label>
              </div>
              <div class="flex align-items-center">
                <p-radiobutton
                  name="dataTransferOutsideSee"
                  inputId="extra-see-no"
                  [value]="false"
                  [(ngModel)]="contract()!.dataProcessing!.dataTransferOutsideSee"
                ></p-radiobutton>
                <label for="extra-see-no" class="ml-2">No</label>
              </div>
            </div>
          } @else {
            <div class="flex align-items-center gap-2">
              <p-tag
                [value]="contract()?.dataProcessing?.dataTransferOutsideSee ? 'Sì' : 'No'"
                [severity]="
                  contract()?.dataProcessing?.dataTransferOutsideSee ? 'success' : 'secondary'
                "
              ></p-tag>
            </div>
          }
        </div>
      </div>

      <!-- Button section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (isEditModeVRF()) {
          <p-button
            label="Annulla"
            icon="pi pi-times"
            [outlined]="true"
            size="small"
            (onClick)="toggleEditVRF()" [attr.aria-label]="'Annulla modifiche VRF'"
            pTooltip="Annulla modifiche"
            tooltipPosition="top"
            title="Annulla modifiche"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (onClick)="saveSection('vrf')" [attr.aria-label]="'Salva modifiche VRF'"
            pTooltip="Salva modifiche"
            tooltipPosition="top"
            title="Salva modifiche"
          ></p-button>
        } @else if (isContractEditable()) {
          <p-button
            label="Modifica"
            icon="pi pi-pencil"
            [outlined]="true"
            size="small"
            [disabled]="hasAnySectionInEditMode()"
            (onClick)="toggleEditVRF()"
            [ariaLabel]="
              hasAnySectionInEditMode()
                ? 'Modifica VRF - disabilitato: completa o annulla le modifiche alla sezione corrente'
                : 'Modifica VRF - trattamento dati'
            "
            [pTooltip]="
              hasAnySectionInEditMode()
                ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                : 'Modifica sezione'
            "
            tooltipPosition="top"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= ATTO DI NOMINA - Intestazione principale ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <div class="mb-4">
        <div class="surface-50 border-round p-4 shadow-1" style="border-left: 5px solid #00125b">
          <div class="flex align-items-center gap-3">
            <i class="pi pi-file-check text-3xl" style="color: #00125b" aria-hidden="true"></i>
            <div>
              <h2 class="text-2xl font-bold m-0" style="color: #00125b">Atto di Nomina</h2>
              <p class="m-0 mt-2" style="color: var(--axa-neutral-700); font-size: 0.95rem">
                Dati GDPR e Responsabilità del Trattamento
              </p>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- ================= SECTION: TITOLARI DEL TRATTAMENTO (conditional on GDPR) ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="titolari-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-building text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="titolari-heading" class="text-xl font-semibold m-0">Titolari del Trattamento</h2>
          <app-section-collapse-toggle sectionName="Titolari del Trattamento"></app-section-collapse-toggle>
        </div>

        @if (!attoDiNomina()?.controllers || attoDiNomina()!.controllers!.length === 0) {
          <div
            class="surface-100 border-round p-4 mb-3 text-center"
            style="color: var(--axa-neutral-800)"
          >
            <i class="pi pi-info-circle mr-2" aria-hidden="true"></i>
            Nessun titolare del trattamento disponibile
          </div>
        } @else {
          @for (controller of attoDiNomina()!.controllers!; track controller.id || $index) {
            <div class="surface-50 border-round p-4 mb-3">
              <div class="flex align-items-center mb-3">
                <h4 class="text-md font-semibold m-0">
                  <i class="pi pi-building mr-2" aria-hidden="true"></i>
                  Titolare del Trattamento #{{ $index + 1 }}
                </h4>
              </div>

              <div class="form-grid">
                <div class="item">
                  <label [for]="'controller-entity-' + $index"
                    >Denominazione Entità
                    <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  @if (isEditModeTitolari()) {
                    <p-select
                      [id]="'controller-entity-' + $index"
                      [(ngModel)]="controller.controllerEntity"
                      [options]="getAvailableControllerEntityOptions($index)"
                      optionLabel="entityDescription"
                      optionValue="entityCode"
                      placeholder="Seleziona entità"
                      (onChange)="onControllerEntityChange(controller)"
                      class="w-full"
                      [attr.aria-required]="true"
                    ></p-select>
                  } @else {
                    <input
                      [id]="'controller-entity-view-' + $index"
                      pInputText
                      [value]="
                        getInvolvedEntityLabel(controller.controllerEntity)
                      "
                      [disabled]="true"
                      class="w-full"
                    />
                  }
                </div>
                <div class="item">
                  <label [for]="'controller-dpo-' + $index"
                    >Email DPO Titolare
                    <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  <input
                    [id]="'controller-dpo-' + $index"
                    pInputText
                    [(ngModel)]="controller.controllerDpoEmail"
                    [disabled]="!isEditModeTitolari()"
                    class="w-full"
                    type="email"
                    placeholder="es. dpo@axa.it"
                    [attr.aria-required]="true"
                  />
                </div>
                <div class="item">
                  <label [for]="'controller-ownership-' + $index"
                    >Tipo Titolarità <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  @if (isEditModeTitolari()) {
                    <p-select
                      [id]="'controller-ownership-' + $index"
                      [(ngModel)]="controller.controllerOwnershipType"
                      [options]="ownershipTypeOptions()"
                      optionLabel="valueDescription"
                      optionValue="valueKey"
                      placeholder="Seleziona tipo"
                      class="w-full"
                      [attr.aria-required]="true"
                    ></p-select>
                  } @else {
                    <input
                      [id]="'controller-ownership-view-' + $index"
                      pInputText
                      [value]="
                        getDropdownLabel(ownershipTypeOptions(), controller.controllerOwnershipType)
                      "
                      [disabled]="true"
                      class="w-full"
                    />
                  }
                </div>
              </div>
            </div>
          }
        }

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeTitolari()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditTitolari()" [attr.aria-label]="'Annulla modifiche titolari'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveTitolari()" [attr.aria-label]="'Salva modifiche titolari'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditTitolari()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica titolari - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica titolari'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: RESPONSABILE DEL TRATTAMENTO ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="responsabile-heading"
      >
        <div
          class="flex align-items-center justify-content-between gap-3 mb-4 pb-3 border-bottom-1 border-200"
        >
          <div class="flex align-items-center gap-3">
            <i class="pi pi-user-edit text-2xl" style="color: #00125b" aria-hidden="true"></i>
            <h2 id="responsabile-heading" class="text-xl font-semibold m-0">
              Responsabile del Trattamento
            </h2>
          </div>
          <div class="flex align-items-center gap-2">
            @if (isEditModeResponsabile() && !isContractProfessional()) {
              <p-button
                icon="pi pi-pencil"
                size="small"
                [outlined]="true"
                severity="info"
                (onClick)="selectResponsibleFromRegistry()"
                pTooltip="Seleziona responsabile dal registro"
                tooltipPosition="top" [attr.aria-label]="'Seleziona responsabile dal registro'"
                title="Seleziona responsabile dal registro"
              ></p-button>
            }
            <app-section-collapse-toggle sectionName="Responsabile del Trattamento"></app-section-collapse-toggle>
          </div>
        </div>

        <!-- Responsabile del trattamento -->
        <div class="form-grid">
          <div class="item">
            <label for="responsible-name"
              >Ragione Sociale Responsabile
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="responsible-name"
              pInputText
              [(ngModel)]="attoDiNomina()!.responsible.responsibleBusinessName"
              [disabled]="true"
              class="w-full"
              [attr.aria-required]="true"
            />
          </div>
          <div class="item">
            <label for="responsible-headquarters"
              >Sede del Responsabile <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="responsible-headquarters"
              pInputText
              [(ngModel)]="attoDiNomina()!.responsible.headquarters"
              [disabled]="!isEditModeResponsabile() || !isContractProfessional()"
              class="w-full"
              [attr.aria-required]="true"
            />
          </div>
          <div class="item">
            <label for="responsible-dpo-email"
              >Email DPO Responsabile <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="responsible-dpo-email"
              pInputText
              type="email"
              [(ngModel)]="attoDiNomina()!.responsible.responsibleDpoEmail"
              [disabled]="!isEditModeResponsabile() || !isContractProfessional()"
              class="w-full"
              [attr.aria-required]="true"
            />
          </div>
          <div class="item">
            <label for="processed-data-types"
              >Dati Trattati dal Responsabile
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeResponsabile()) {
              <p-multiselect
                id="processed-data-types"
                [(ngModel)]="attoDiNomina()!.responsible.processedDataTypes"
                [options]="processedDataTypesOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona tipologie"
                display="chip"
                class="w-full"
                [attr.aria-required]="true"
              ></p-multiselect>
            } @else {
              <input
                id="processed-data-types-view"
                pInputText
                [value]="
                  getMultiDropdownLabels(
                    processedDataTypesOptions(),
                    attoDiNomina()?.responsible?.processedDataTypes
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>

          <div class="item full-width">
            <label for="processed-data-notes">Note sui Dati Trattati</label>
            <textarea
              id="processed-data-notes"
              pInputTextarea
              [(ngModel)]="attoDiNomina()!.responsible.processedDataNotes"
              [disabled]="!isEditModeResponsabile()"
              rows="2"
              class="w-full"
              placeholder="Specifica quali dati vengono trattati (opzionale)"
            ></textarea>
          </div>

          <div class="item full-width">
            <label for="process-description"
              >Descrizione Sintetica del Processo
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <textarea
              id="process-description"
              pInputTextarea
              [(ngModel)]="attoDiNomina()!.responsible.processDescription"
              [disabled]="!isEditModeResponsabile()"
              rows="3"
              class="w-full"
              [attr.aria-required]="true"
            ></textarea>
          </div>

          <div class="item">
            <label for="responsible-type"
              >Tipologia di Responsabile
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeResponsabile()) {
              <p-select
                id="responsible-type"
                [(ngModel)]="attoDiNomina()!.responsible.responsibleType"
                [options]="responsibleTypeOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona tipologia"
                class="w-full"
                [attr.aria-required]="true"
              ></p-select>
            } @else {
              <input
                id="responsible-type-view"
                pInputText
                [value]="
                  getDropdownLabel(
                    responsibleTypeOptions(),
                    attoDiNomina()?.responsible?.responsibleType
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>

          <div class="item">
            <label for="processing-location"
              >Luogo Trattamento Dati <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeResponsabile()) {
              <p-select
                id="processing-location"
                [(ngModel)]="attoDiNomina()!.responsible.dataProcessingLocation"
                [options]="countriesOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona paese"
                [filter]="true"
                filterPlaceholder="Cerca paese"
                class="w-full"
                [attr.aria-required]="true"
              ></p-select>
            } @else {
              <input
                id="processing-location-view"
                pInputText
                [value]="
                  getDropdownLabel(
                    countriesOptions(),
                    attoDiNomina()?.responsible?.dataProcessingLocation
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>

          <div class="item full-width">
            <label for="external-sys-admins"
              >Amministratore di Sistema
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <textarea
              id="external-sys-admins"
              pInputTextarea
              [(ngModel)]="attoDiNomina()!.responsible.externalSysAdminsText"
              [disabled]="!isEditModeResponsabile()"
              rows="2"
              class="w-full"
              [attr.aria-required]="true"
            ></textarea>
          </div>

          <div class="item">
            <label for="transfer-outside-eu"
              >Trasferimento Extra UE <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeResponsabile()) {
              <div class="flex gap-4" role="radiogroup" aria-label="Trasferimento Extra UE">
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="transferOutsideEu"
                    inputId="transfer-outside-eu-yes"
                    [value]="true"
                    [(ngModel)]="attoDiNomina()!.responsible!.transferOutsideEu"
                  ></p-radiobutton>
                  <label for="transfer-outside-eu-yes" class="ml-2">Sì</label>
                </div>
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="transferOutsideEu"
                    inputId="transfer-outside-eu-no"
                    [value]="false"
                    [(ngModel)]="attoDiNomina()!.responsible!.transferOutsideEu"
                  ></p-radiobutton>
                  <label for="transfer-outside-eu-no" class="ml-2">No</label>
                </div>
              </div>
            } @else {
              <div class="flex align-items-center gap-2">
                <p-tag
                  [value]="attoDiNomina()?.responsible?.transferOutsideEu ? 'Sì' : 'No'"
                  [severity]="
                    attoDiNomina()?.responsible?.transferOutsideEu ? 'success' : 'secondary'
                  "
                ></p-tag>
              </div>
            }
          </div>

          @if (attoDiNomina()?.responsible?.transferOutsideEu) {
            <div class="item">
              <label for="extra-eu-legal-basis"
                >Base Legale Trasferimento
                <span class="text-red-500" aria-hidden="true">*</span></label
              >
              <input
                id="extra-eu-legal-basis"
                pInputText
                [(ngModel)]="attoDiNomina()!.responsible.extraEuLegalBasis"
                [disabled]="!isEditModeResponsabile()"
                class="w-full"
                placeholder="es. Clausole contrattuali tipo"
                [attr.aria-required]="true"
              />
            </div>

            <div class="item">
              <label for="third-country"
                >Paese Terzo del Trasferimento
                <span class="text-red-500" aria-hidden="true">*</span></label
              >
              @if (isEditModeResponsabile()) {
                <p-select
                  id="third-country"
                  [(ngModel)]="attoDiNomina()!.responsible.thirdCountry"
                  [options]="nonEuCountriesOptions()"
                  optionLabel="valueDescription"
                  optionValue="valueKey"
                  placeholder="Seleziona paese extra UE"
                  [filter]="true"
                  filterPlaceholder="Cerca paese"
                  class="w-full"
                  [attr.aria-required]="true"
                ></p-select>
              } @else {
                <input
                  id="third-country-view"
                  pInputText
                  [value]="
                    getDropdownLabel(
                      nonEuCountriesOptions(),
                      attoDiNomina()?.responsible?.thirdCountry
                    )
                  "
                  [disabled]="true"
                  class="w-full"
                />
              }
            </div>

            <div class="item">
              <label for="tia-done"
                >Effettuata TIA <span class="text-red-500" aria-hidden="true">*</span></label
              >
              @if (isEditModeResponsabile()) {
                <div class="flex gap-4" role="radiogroup" aria-label="Effettuata TIA">
                  <div class="flex align-items-center">
                    <p-radiobutton
                      name="tiaDone"
                      inputId="tia-done-yes"
                      [value]="true"
                      [(ngModel)]="attoDiNomina()!.responsible!.tiaDone"
                    ></p-radiobutton>
                    <label for="tia-done-yes" class="ml-2">Sì</label>
                  </div>
                  <div class="flex align-items-center">
                    <p-radiobutton
                      name="tiaDone"
                      inputId="tia-done-no"
                      [value]="false"
                      [(ngModel)]="attoDiNomina()!.responsible!.tiaDone"
                    ></p-radiobutton>
                    <label for="tia-done-no" class="ml-2">No</label>
                  </div>
                </div>
              } @else {
                <div class="flex align-items-center gap-2">
                  <p-tag
                    [value]="attoDiNomina()?.responsible?.tiaDone ? 'Sì' : 'No'"
                    [severity]="attoDiNomina()?.responsible?.tiaDone ? 'success' : 'secondary'"
                  ></p-tag>
                </div>
              }
            </div>

            @if (attoDiNomina()?.responsible?.tiaDone === true) {
              <div class="item full-width">
                <label for="tia-outcome"
                  >Esito TIA <span class="text-red-500" aria-hidden="true">*</span></label
                >
                @if (isEditModeResponsabile()) {
                  <textarea
                    id="tia-outcome"
                    pInputTextarea
                    [(ngModel)]="attoDiNomina()!.responsible!.tiaOutcome"
                    rows="3"
                    class="w-full"
                    [attr.aria-required]="true"
                  ></textarea>
                } @else {
                  <textarea
                    id="tia-outcome-view"
                    pInputTextarea
                    [value]="attoDiNomina()?.responsible?.tiaOutcome || ''"
                    [disabled]="true"
                    rows="3"
                    class="w-full"
                  ></textarea>
                }
              </div>
            }
          }

          <div class="item">
            <label for="data-deletion-program"
              >Programma di Data Deletion Previsto
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeResponsabile()) {
              <div
                class="flex gap-4"
                role="radiogroup"
                aria-label="Programma di Data Deletion Previsto"
              >
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="dataDeletionProgram"
                    inputId="data-deletion-yes"
                    [value]="true"
                    [(ngModel)]="attoDiNomina()!.responsible!.dataDeletionProgram"
                  ></p-radiobutton>
                  <label for="data-deletion-yes" class="ml-2">Sì</label>
                </div>
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="dataDeletionProgram"
                    inputId="data-deletion-no"
                    [value]="false"
                    [(ngModel)]="attoDiNomina()!.responsible!.dataDeletionProgram"
                  ></p-radiobutton>
                  <label for="data-deletion-no" class="ml-2">No</label>
                </div>
              </div>
            } @else {
              <div class="flex align-items-center gap-2">
                <p-tag
                  [value]="attoDiNomina()?.responsible?.dataDeletionProgram ? 'Sì' : 'No'"
                  [severity]="
                    attoDiNomina()?.responsible?.dataDeletionProgram ? 'success' : 'secondary'
                  "
                ></p-tag>
              </div>
            }
          </div>

          <div class="item">
            <label for="critical-supplier"
              >Qualificazione Fornitore Critico
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeResponsabile()) {
              <p-select
                id="critical-supplier"
                [(ngModel)]="attoDiNomina()!.responsible.criticalSupplierQualification"
                [options]="criticalSupplierQualificationOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona qualificazione"
                class="w-full"
                [attr.aria-required]="true"
              ></p-select>
            } @else {
              <input
                id="critical-supplier-view"
                pInputText
                [value]="
                  getDropdownLabel(
                    criticalSupplierQualificationOptions(),
                    attoDiNomina()?.responsible?.criticalSupplierQualification
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>

          <!-- Note per Registro Responsabili trattamento -->
          <div class="item full-width">
            <label for="responsible-notes">Note per Registro Responsabili trattamento</label>
            <textarea
              id="responsible-notes"
              pInputTextarea
              [(ngModel)]="attoDiNomina()!.responsible.notes"
              [disabled]="!isEditModeResponsabile()"
              rows="2"
              class="w-full"
              placeholder="Note generali (opzionale)"
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeResponsabile()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditResponsabile()" [attr.aria-label]="'Annulla modifiche responsabile'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveResponsabile()" [attr.aria-label]="'Salva modifiche responsabile'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditResponsabile()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica responsabile - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica responsabile'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: SUB-RESPONSABILI DEL TRATTAMENTO ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="sub-responsabili-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-sitemap text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="sub-responsabili-heading" class="text-xl font-semibold m-0">
            Sub-Responsabili del Trattamento
          </h2>
          <app-section-collapse-toggle sectionName="Sub-Responsabili del Trattamento"></app-section-collapse-toggle>
        </div>

        <!-- Il Responsabile fa ricorso a Sub-Responsabili? -->
        <div class="form-grid">
          <div class="item">
            <label for="uses-sub-responsibles">
              Il Responsabile fa ricorso a Sub-Responsabili?
              <span class="text-red-500" aria-hidden="true">*</span>
            </label>
            @if (isEditModeSubResponsabili()) {
              <div
                class="flex gap-4"
                role="radiogroup"
                aria-label="Il Responsabile fa ricorso a Sub-Responsabili"
              >
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="usesSubResponsibles"
                    inputId="uses-sub-responsibles-yes-detail"
                    [value]="true"
                    [(ngModel)]="attoDiNomina()!.responsible!.usesSubResponsibles"
                  ></p-radiobutton>
                  <label for="uses-sub-responsibles-yes-detail" class="ml-2">Sì</label>
                </div>
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="usesSubResponsibles"
                    inputId="uses-sub-responsibles-no-detail"
                    [value]="false"
                    [(ngModel)]="attoDiNomina()!.responsible!.usesSubResponsibles"
                  ></p-radiobutton>
                  <label for="uses-sub-responsibles-no-detail" class="ml-2">No</label>
                </div>
              </div>
            } @else {
              <div class="flex align-items-center gap-2">
                <p-tag
                  [value]="attoDiNomina()?.responsible?.usesSubResponsibles ? 'Sì' : 'No'"
                  [severity]="
                    attoDiNomina()?.responsible?.usesSubResponsibles ? 'success' : 'secondary'
                  "
                ></p-tag>
              </div>
            }
          </div>
        </div>

        @if (attoDiNomina()?.responsible?.usesSubResponsibles) {
          <div class="flex align-items-center justify-content-between mb-3 mt-4">
          <p class="m-0 text-color-secondary">
            Elenco dei sub-responsabili nominati dal Responsabile del Trattamento
          </p>
          @if (isEditModeSubResponsabili()) {
            <p-button
              label="Aggiungi Sub-Responsabile"
              icon="pi pi-plus"
              size="small"
              (onClick)="addSubResponsible()"
              [outlined]="true"
              severity="success" [attr.aria-label]="'Aggiungi sub-responsabile'"
              title="Aggiungi sub-responsabile"
            ></p-button>
          }
        </div>

        @if (
          !attoDiNomina()?.responsible?.subResponsibles ||
          attoDiNomina()!.responsible!.subResponsibles.length === 0
        ) {
          <div
            class="text-center p-4 border-round mb-3 surface-100"
            style="color: var(--axa-neutral-800)"
            role="status"
            aria-live="polite"
          >
            <i class="pi pi-info-circle mr-2" aria-hidden="true"></i>
            @if (isEditModeSubResponsabili()) {
              <span
                >Nessun sub-responsabile presente. Clicca su "Aggiungi Sub-Responsabile" per
                iniziare.</span
              >
            } @else {
              <span>Nessun sub-responsabile presente.</span>
            }
          </div>
        } @else {
          @for (sub of attoDiNomina()!.responsible!.subResponsibles; track $index) {
            <div class="surface-100 border-round p-4 border-1 border-300 mb-3">
              <!-- Header Card -->
              <div
                class="flex align-items-center justify-content-between mb-3 pb-2 border-bottom-1 border-200"
              >
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-sitemap text-xl" style="color: #00125b" aria-hidden="true"></i>
                  <h5 class="text-base font-semibold m-0">
                    Sub-Responsabile #{{ $index + 1 }}
                    @if (sub.businessName) {
                      <span class="font-normal" style="color: var(--axa-neutral-700)">
                        - {{ sub.businessName }}</span
                      >
                    }
                  </h5>
                </div>
                @if (isEditModeSubResponsabili() && !isContractProfessional()) {
                  <div class="flex gap-2">
                    <p-button
                      icon="pi pi-pencil"
                      size="small"
                      [outlined]="true"
                      severity="info"
                      (onClick)="selectSubResponsibleFromRegistry($index)"
                      pTooltip="Seleziona dal registro"
                      tooltipPosition="top" [attr.aria-label]="'Seleziona sub-responsabile dal registro'"
                      title="Seleziona sub-responsabile dal registro"
                    ></p-button>
                    <p-button
                      icon="pi pi-trash"
                      size="small"
                      [outlined]="true"
                      severity="danger"
                      (onClick)="removeSubResponsible($index)"
                      pTooltip="Elimina sub-responsabile"
                      tooltipPosition="top" [attr.aria-label]="'Elimina sub-responsabile'"
                      title="Elimina sub-responsabile"
                      title="Elimina sub-responsabile"
                    ></p-button>
                  </div>
                }
              </div>

              <!-- Dati Sub-Responsabile -->
              <div class="form-grid">
                <div class="item">
                  <label [for]="'sub-business-name-' + $index"
                    >Ragione Sociale <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  <input
                    [id]="'sub-business-name-' + $index"
                    pInputText
                    [(ngModel)]="attoDiNomina()!.responsible!.subResponsibles[$index].businessName"
                    [disabled]="true"
                    class="w-full"
                    [attr.aria-required]="true"
                  />
                </div>
                <div class="item">
                  <label [for]="'sub-headquarters-' + $index"
                    >Sede Legale <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  <input
                    [id]="'sub-headquarters-' + $index"
                    pInputText
                    [(ngModel)]="attoDiNomina()!.responsible!.subResponsibles[$index].headquarters"
                    [disabled]="true"
                    class="w-full"
                    [attr.aria-required]="true"
                  />
                </div>
                <div class="item">
                  <label [for]="'sub-email-' + $index"
                    >Email</label
                  >
                  <input
                    [id]="'sub-email-' + $index"
                    pInputText
                    [(ngModel)]="attoDiNomina()!.responsible!.subResponsibles[$index].email"
                    [disabled]="true"
                    class="w-full"
                    type="email"
                  />
                </div>
                <div class="item">
                  <label [for]="'sub-data-processing-location-' + $index"
                    >Luogo Trattamento Dati
                    <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  @if (isEditModeSubResponsabili()) {
                    <p-select
                      [id]="'sub-data-processing-location-' + $index"
                      [(ngModel)]="
                        attoDiNomina()!.responsible!.subResponsibles[$index].dataProcessingLocation
                      "
                      [options]="subDataProcessingLocationOptions()"
                      optionLabel="valueDescription"
                      optionValue="valueKey"
                      placeholder="Seleziona luogo"
                      class="w-full"
                      [attr.aria-required]="true"
                    ></p-select>
                  } @else {
                    <input
                      [id]="'sub-data-processing-location-view-' + $index"
                      pInputText
                      [value]="
                        getDropdownLabel(
                          subDataProcessingLocationOptions(),
                          sub.dataProcessingLocation
                        )
                      "
                      [disabled]="true"
                      class="w-full"
                    />
                  }
                </div>

                @if (sub.dataProcessingLocation === 'UE' || sub.dataProcessingLocation === 'EXTRA_UE') {
                  <div class="item">
                    <label [for]="'sub-data-processing-country-' + $index"
                      >Paese trattamento dati <span class="text-red-500" aria-hidden="true">*</span></label
                    >
                    @if (isEditModeSubResponsabili()) {
                      <p-select
                        [id]="'sub-data-processing-country-' + $index"
                        [(ngModel)]="
                          attoDiNomina()!.responsible!.subResponsibles[$index].dataProcessingCountry
                        "
                        [options]="luogoTrattamentoOptions()"
                        optionLabel="valueDescription"
                        optionValue="valueKey"
                        placeholder="Seleziona paese"
                        [filter]="true"
                        filterPlaceholder="Cerca paese"
                        class="w-full"
                        [attr.aria-required]="true"
                      ></p-select>
                    } @else {
                      <input
                        [id]="'sub-data-processing-country-view-' + $index"
                        pInputText
                        [value]="getDropdownLabel(luogoTrattamentoOptions(), sub.dataProcessingCountry)"
                        [disabled]="true"
                        class="w-full"
                      />
                    }
                  </div>
                }

                @if (sub.dataProcessingLocation === 'EXTRA_UE') {
                  <div class="item full-width">
                    <label [for]="'sub-non-eu-safeguard-' + $index"
                      >Garanzie per Trasferimento Extra UE
                      <span class="text-red-500" aria-hidden="true">*</span></label
                    >
                    <textarea
                      [id]="'sub-non-eu-safeguard-' + $index"
                      pInputTextarea
                      [(ngModel)]="
                        attoDiNomina()!.responsible!.subResponsibles[$index].nonEuSafeguard
                      "
                      [disabled]="!isEditModeSubResponsabili()"
                      rows="2"
                      class="w-full"
                      [attr.aria-required]="true"
                    ></textarea>
                  </div>
                }

                <div class="item full-width">
                  <label [for]="'sub-data-types-' + $index"
                    >Tipo Dati Trattati
                    <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  @if (isEditModeSubResponsabili()) {
                    <p-multiselect
                      [id]="'sub-data-types-' + $index"
                      [(ngModel)]="attoDiNomina()!.responsible!.subResponsibles[$index].dataTypes"
                      [options]="processedDataTypesOptions()"
                      optionLabel="valueDescription"
                      optionValue="valueKey"
                      placeholder="Seleziona tipologie"
                      display="chip"
                      class="w-full"
                      [attr.aria-required]="true"
                    ></p-multiselect>
                  } @else {
                    <input
                      [id]="'sub-data-types-view-' + $index"
                      pInputText
                      [value]="getMultiDropdownLabels(processedDataTypesOptions(), sub.dataTypes)"
                      [disabled]="true"
                      class="w-full"
                    />
                  }
                </div>

                <div class="item full-width">
                  <label [for]="'sub-data-types-notes-' + $index">Note sui Dati Trattati</label>
                  <textarea
                    [id]="'sub-data-types-notes-' + $index"
                    pInputTextarea
                    [(ngModel)]="
                      attoDiNomina()!.responsible!.subResponsibles[$index].dataTypesNotes
                    "
                    [disabled]="!isEditModeSubResponsabili()"
                    rows="2"
                    class="w-full"
                  ></textarea>
                </div>

                <div class="item full-width">
                  <label [for]="'sub-delegated-processes-' + $index"
                    >Descrizione Processi Affidati
                    <span class="text-red-500" aria-hidden="true">*</span></label
                  >
                  <textarea
                    [id]="'sub-delegated-processes-' + $index"
                    pInputTextarea
                    [(ngModel)]="
                      attoDiNomina()!.responsible!.subResponsibles[$index]
                        .delegatedProcessesDescription
                    "
                    [disabled]="!isEditModeSubResponsabili()"
                    rows="3"
                    class="w-full"
                    [attr.aria-required]="true"
                  ></textarea>
                </div>

                <div class="item full-width">
                  <label [for]="'sub-notes-' + $index">
                    Note per Registro Sub Responsabili trattamento
                  </label>
                  <textarea
                    [id]="'sub-notes-' + $index"
                    pInputTextarea
                    [(ngModel)]="attoDiNomina()!.responsible!.subResponsibles[$index].notes"
                    [disabled]="!isEditModeSubResponsabili()"
                    rows="2"
                    class="w-full"
                    placeholder="Note aggiuntive (opzionale)"
                  ></textarea>
                </div>
              </div>
            </div>
          }
        }
      }

      <!-- Button section footer -->
      <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (isEditModeSubResponsabili()) {
          <p-button
            label="Annulla"
            icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditSubResponsabili()" [attr.aria-label]="'Annulla modifiche sub-responsabili'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveSubResponsabili()" [attr.aria-label]="'Salva modifiche sub-responsabili'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditSubResponsabili()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica sub-responsabili - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica sub-responsabili'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- =================SECTION: OPERAZIONI DI TRATTAMENTO ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="operazioni-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-cog text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="operazioni-heading" class="text-xl font-semibold m-0">
            Operazioni di Trattamento
          </h2>
          <app-section-collapse-toggle sectionName="Operazioni di Trattamento"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="activity-description"
              >Specificare brevemente le attività pertinenti al trattamento
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <textarea
              id="activity-description"
              pInputTextarea
              [ngModel]="
                isEditModeOperazioniTrattamento()
                  ? attoDiNomina()!.activityDescription
                  : getDropdownText(activityDescriptionOptions(), attoDiNomina()!.activityDescription)
              "
              (ngModelChange)="attoDiNomina()!.activityDescription = $event"
              [disabled]="!isEditModeOperazioniTrattamento()"
              rows="3"
              class="w-full"
              [attr.aria-required]="true"
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeOperazioniTrattamento()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditOperazioniTrattamento()" [attr.aria-label]="'Annulla modifiche operazioni trattamento'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveOperazioniTrattamento()" [attr.aria-label]="'Salva modifiche operazioni trattamento'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditOperazioniTrattamento()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica operazioni trattamento - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica operazioni trattamento'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: FINALITÀ DEL TRATTAMENTO ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="finalita-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-flag text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="finalita-heading" class="text-xl font-semibold m-0">Finalità del Trattamento</h2>
          <app-section-collapse-toggle sectionName="Finalit? del Trattamento"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="main-purpose"
              >Specificare brevemente lo scopo o gli scopi di trattamento dei dati
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <textarea
              id="main-purpose"
              pInputTextarea
              [ngModel]="
                isEditModeFinalitaTrattamento()
                  ? attoDiNomina()!.mainPurpose
                  : getDropdownText(mainPurposeOptions(), attoDiNomina()!.mainPurpose)
              "
              (ngModelChange)="attoDiNomina()!.mainPurpose = $event"
              [disabled]="!isEditModeFinalitaTrattamento()"
              rows="3"
              class="w-full"
              placeholder="es. Erogazione servizi, gestione contratti, adempimenti fiscali"
              [attr.aria-required]="true"
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeFinalitaTrattamento()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditFinalitaTrattamento()" [attr.aria-label]="'Annulla modifiche finalità trattamento'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveFinalitaTrattamento()" [attr.aria-label]="'Salva modifiche finalità trattamento'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditFinalitaTrattamento()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica finalità trattamento - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica finalità trattamento'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: CATEGORIE DI SOGGETTI ================= -->
    @if (contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="categorie-soggetti-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-users text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="categorie-soggetti-heading" class="text-xl font-semibold m-0">
            Categorie di Soggetti
          </h2>
          <app-section-collapse-toggle sectionName="Categorie di Soggetti"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="category"
              >Categorie di persone fisiche i cui dati sono oggetto di trattamento
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeCategorieSoggetti()) {
              <p-multi-select
                id="category"
                [(ngModel)]="attoDiNomina()!.category"
                [options]="subjectCategoryOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona categorie (multiplo)"
                [showClear]="true"
                class="w-full"
                [attr.aria-required]="true"
              ></p-multi-select>
            } @else {
              <input
                id="category-view"
                pInputText
                [value]="getMultiDropdownLabels(subjectCategoryOptions(), attoDiNomina()?.category)"
                [disabled]="true"
                class="w-full"
              />
            }
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeCategorieSoggetti()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditCategorieSoggetti()" [attr.aria-label]="'Annulla modifiche categorie soggetti'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveCategorieSoggetti()" [attr.aria-label]="'Salva modifiche categorie soggetti'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditCategorieSoggetti()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica categorie soggetti - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica categorie soggetti'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: DESTINATARI UE/extra UE ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="destinatari-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-send text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="destinatari-heading" class="text-xl font-semibold m-0">
            Destinatari UE/extra UE
          </h2>
          <app-section-collapse-toggle sectionName="Destinatari UE/extra UE"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="recipient-category"
              >Specificare brevemente le categorie dei soggetti a cui i dati sono comunicati
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            @if (isEditModeDestinatari()) {
              <p-multi-select
                id="recipient-category"
                [(ngModel)]="attoDiNomina()!.recipientCategory"
                [options]="recipientCategoryOptions()"
                optionLabel="valueDescription"
                optionValue="valueKey"
                placeholder="Seleziona categorie (multiplo)"
                [showClear]="true"
                class="w-full"
                [attr.aria-required]="true"
              ></p-multi-select>
            } @else {
              <input
                id="recipient-category-view"
                pInputText
                [value]="
                  getMultiDropdownLabels(
                    recipientCategoryOptions(),
                    attoDiNomina()?.recipientCategory
                  )
                "
                [disabled]="true"
                class="w-full"
              />
            }
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeDestinatari()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditDestinatari()" [attr.aria-label]="'Annulla modifiche destinatari'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveDestinatari()" [attr.aria-label]="'Salva modifiche destinatari'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditDestinatari()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica destinatari - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica destinatari'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: CONSERVAZIONE E CANCELLAZIONE ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="conservazione-cancellazione-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-calendar text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="conservazione-cancellazione-heading" class="text-xl font-semibold m-0">
            Conservazione e Cancellazione
          </h2>
          <app-section-collapse-toggle sectionName="Conservazione e Cancellazione"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item">
            <label for="retention-period"
              >Periodo di conservazione del dato (anni)
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <p-input-number
              id="retention-period"
              [(ngModel)]="attoDiNomina()!.retentionPeriod"
              [disabled]="!isEditModeConservazioneCancellazione()"
              suffix=" anni"
              [min]="0"
              placeholder="es. 10"
              class="w-full"
              [attr.aria-required]="true"
            ></p-input-number>
          </div>
          <div class="item">
            <label for="retention-criteria">Criteri per determinare tale periodo</label>
            <input
              id="retention-criteria"
              pInputText
              [(ngModel)]="attoDiNomina()!.retentionCriteria"
              [disabled]="!isEditModeConservazioneCancellazione()"
              class="w-full"
            />
          </div>
          <div class="item">
            <label for="deletion-method"
              >Modalità di cancellazione
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <input
              id="deletion-method"
              pInputText
              [ngModel]="
                isEditModeConservazioneCancellazione()
                  ? attoDiNomina()!.deletionMethod
                  : getDropdownText(deletionMethodOptions(), attoDiNomina()!.deletionMethod)
              "
              (ngModelChange)="attoDiNomina()!.deletionMethod = $event"
              [disabled]="!isEditModeConservazioneCancellazione()"
              class="w-full"
              [attr.aria-required]="true"
            />
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeConservazioneCancellazione()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditConservazioneCancellazione()" [attr.aria-label]="'Annulla modifiche conservazione e cancellazione'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveConservazioneCancellazione()" [attr.aria-label]="'Salva modifiche conservazione e cancellazione'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditConservazioneCancellazione()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica conservazione e cancellazione - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica conservazione e cancellazione'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: STRUMENTI UTILIZZATI ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="strumenti-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-wrench text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="strumenti-heading" class="text-xl font-semibold m-0">Strumenti Utilizzati</h2>
          <app-section-collapse-toggle sectionName="Strumenti Utilizzati"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="other-tools"
              >Specificare brevemente la strumentazione utilizzata per il trattamento dei dati
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <textarea
              id="other-tools"
              pInputTextarea
              [(ngModel)]="attoDiNomina()!.otherTools"
              [disabled]="!isEditModeStrumentiUtilizzati()"
              rows="3"
              class="w-full"
              [attr.aria-required]="true"
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeStrumentiUtilizzati()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditStrumentiUtilizzati()" [attr.aria-label]="'Annulla modifiche strumenti utilizzati'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveStrumentiUtilizzati()" [attr.aria-label]="'Salva modifiche strumenti utilizzati'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditStrumentiUtilizzati()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica strumenti utilizzati - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica strumenti utilizzati'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: MISURE DI SICUREZZA ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="misure-sicurezza-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-shield text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="misure-sicurezza-heading" class="text-xl font-semibold m-0">
            Misure di Sicurezza
          </h2>
          <app-section-collapse-toggle sectionName="Misure di Sicurezza"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="measure"
              >Specificare brevemente le misure tecniche e organizzative messe in atto
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <textarea
              id="measure"
              pInputTextarea
              [(ngModel)]="attoDiNomina()!.measure"
              [disabled]="!isEditModeMisureSicurezza()"
              rows="4"
              class="w-full"
              [attr.aria-required]="true"
            ></textarea>
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeMisureSicurezza()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditMisureSicurezza()" [attr.aria-label]="'Annulla modifiche misure sicurezza'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveMisureSicurezza()" [attr.aria-label]="'Salva modifiche misure sicurezza'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditMisureSicurezza()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica misure sicurezza - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica misure sicurezza'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: AMMINISTRATORI DI SISTEMA ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="amministratori-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-user-edit text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="amministratori-heading" class="text-xl font-semibold m-0">
            Amministratori di Sistema
          </h2>
          <app-section-collapse-toggle sectionName="Amministratori di Sistema"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <div class="item full-width">
            <label for="admins-text"
              >Elenco amministratori di sistema
              <span class="text-red-500" aria-hidden="true">*</span></label
            >
            <textarea
              id="admins-text"
              pInputTextarea
              [(ngModel)]="attoDiNomina()!.adminsText"
              (ngModelChange)="adminsTextValidationError.set(null)"
              [disabled]="!isEditModeAmministratoriSistema()"
              rows="3"
              class="w-full"
              [attr.aria-required]="true"
              [attr.aria-invalid]="isEditModeAmministratoriSistema() && !!adminsTextValidationError()"
            ></textarea>
            @if (isEditModeAmministratoriSistema() && adminsTextValidationError()) {
              <small class="text-red-500 block mt-2" role="alert">{{ adminsTextValidationError() }}</small>
            }
          </div>
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeAmministratoriSistema()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditAmministratoriSistema()" [attr.aria-label]="'Annulla modifiche amministratori sistema'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveAmministratoriSistema()" [attr.aria-label]="'Salva modifiche amministratori sistema'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditAmministratoriSistema()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica amministratori sistema - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica amministratori sistema'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: INFORMAZIONI SUL CLOUD ================= -->
    @if (isContractProfessional() || contract()?.dataProcessing?.gdprDataProcessing) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="cloud-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-cloud text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="cloud-heading" class="text-xl font-semibold m-0">Informazioni sul Cloud</h2>
          <app-section-collapse-toggle sectionName="Informazioni sul Cloud"></app-section-collapse-toggle>
        </div>

        <div class="form-grid">
          <!-- Indicare se il Responsabile utilizza il Cloud -->
          <div class="item full-width">
            <label>Indicare se il Responsabile utilizza il Cloud</label>
            @if (isEditModeInformazioniCloud()) {
              <div
                class="flex gap-4"
                role="radiogroup"
                aria-label="Indicare se il Responsabile utilizza il Cloud"
              >
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="usesCloud"
                    inputId="uses-cloud-yes"
                    [value]="true"
                    [(ngModel)]="attoDiNomina()!.usesCloud"
                  ></p-radiobutton>
                  <label for="uses-cloud-yes" class="ml-2">Sì</label>
                </div>
                <div class="flex align-items-center">
                  <p-radiobutton
                    name="usesCloud"
                    inputId="uses-cloud-no"
                    [value]="false"
                    [(ngModel)]="attoDiNomina()!.usesCloud"
                  ></p-radiobutton>
                  <label for="uses-cloud-no" class="ml-2">No</label>
                </div>
              </div>
            } @else {
              <div class="flex align-items-center gap-2">
                <p-tag
                  [value]="attoDiNomina()?.usesCloud ? 'Sì' : 'No'"
                  [severity]="attoDiNomina()?.usesCloud ? 'success' : 'secondary'"
                ></p-tag>
              </div>
            }
          </div>

          <!-- Tipologia di Cloud (visibile solo se usesCloud = true) -->
          @if (attoDiNomina()?.usesCloud) {
            <div class="item full-width">
              <label for="cloud-info"
                >Tipologia del cloud (es. Oracle Cloud, Azure Cloud etc.)
                <span class="text-red-500" aria-hidden="true">*</span></label
              >
              <textarea
                id="cloud-info"
                pInputTextarea
                [(ngModel)]="attoDiNomina()!.cloudInfo"
                [disabled]="!isEditModeInformazioniCloud()"
                rows="2"
                class="w-full"
                placeholder="es. Cloud AWS, cloud pubblico, PaaS, IaaS, SaaS"
                [attr.aria-required]="true"
              ></textarea>
            </div>
          }
        </div>

        <!-- Button section footer -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeInformazioniCloud()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              [outlined]="true"
              size="small"
              (onClick)="toggleEditInformazioniCloud()" [attr.aria-label]="'Annulla modifiche informazioni cloud'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              size="small"
              (onClick)="saveInformazioniCloud()" [attr.aria-label]="'Salva modifiche informazioni cloud'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else if (isContractEditable()) {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              size="small"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditInformazioniCloud()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica informazioni cloud - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica informazioni cloud'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica sezione'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: MODIFICA TEMPLATE (solo per GENERATED) ================= -->
    @if (isContractEditable()) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="templates-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-file-edit text-2xl" style="color: #667eea" aria-hidden="true"></i>
          <h2 id="templates-heading" class="text-xl font-semibold m-0" style="color: #00125b">
            Template Documento
          </h2>
          <app-section-collapse-toggle sectionName="Template Documento"></app-section-collapse-toggle>
        </div>

        <div class="grid">
          <!-- Template Contratto -->
          <div class="col-12 md:col-6">
            <div class="item">
              <label class="font-semibold block mb-3"
                >Template Contratto <span class="text-red-500" aria-hidden="true">*</span></label
              >

              @if (isEditModeTemplates()) {
                @if (!selectedContractTemplate()) {
                  <!-- Pulsante per aprire il dialog se non c'è selezione -->
                  <p-button
                    label="Seleziona dal Registro Template"
                    icon="pi pi-search"
                    [outlined]="true"
                    styleClass="w-full justify-content-center"
                    (onClick)="openTemplateContrattoDialog()" [attr.aria-label]="'Seleziona template contratto dal registro'"
                    title="Seleziona template contratto dal registro"
                  ></p-button>
                  <small class="text-muted block mt-2">
                    <i class="pi pi-info-circle mr-1" aria-hidden="true"></i>
                    Seleziona un template contratto dal registro
                  </small>
                } @else {
                  <!-- Card del template selezionato -->
                  <div class="surface-100 border-round p-4 border-1 border-300">
                    <div class="flex justify-content-between align-items-start">
                      <div class="flex-1">
                        <div class="flex align-items-center gap-2 mb-2">
                          <i
                            class="pi pi-file text-xl"
                            style="color: #00125b"
                            aria-hidden="true"
                          ></i>
                          <h4 class="text-lg font-semibold m-0">
                            {{ selectedContractTemplate()!.label }}
                          </h4>
                        </div>
                      </div>
                      <div class="flex gap-2">
                        <p-button
                          icon="pi pi-pencil"
                          [text]="true"
                          [rounded]="true"
                          severity="secondary"
                          pTooltip="Cambia template"
                          tooltipPosition="top"
                          (onClick)="openTemplateContrattoDialog()" [attr.aria-label]="'Cambia template contratto selezionato'"
                          title="Cambia template contratto selezionato"
                        ></p-button>
                        <p-button
                          icon="pi pi-times"
                          [text]="true"
                          [rounded]="true"
                          severity="danger"
                          pTooltip="Rimuovi selezione"
                          tooltipPosition="top"
                          (onClick)="clearTemplateContratto()" [attr.aria-label]="'Rimuovi template contratto selezionato'"
                          title="Rimuovi template contratto selezionato"
                        ></p-button>
                      </div>
                    </div>
                  </div>
                }
              } @else {
                <!-- View mode -->
                @if (selectedContractTemplate()) {
                  <div class="surface-100 border-round p-4 border-1 border-200">
                    <div class="flex align-items-center gap-2">
                      <i class="pi pi-file text-xl" style="color: #00125b" aria-hidden="true"></i>
                      <span class="font-semibold">{{ selectedContractTemplate()!.label }}</span>
                    </div>
                  </div>
                } @else {
                  <div class="text-muted">Non selezionato</div>
                }
              }
            </div>
          </div>

          <!-- Template Atto di Nomina - Visibile solo se GDPR è abilitato -->
          @if (shouldShowAttoDiNominaTemplate()) {
            <div class="col-12 md:col-6">
              <div class="item">
                <label class="font-semibold block mb-3"
                  >Template Atto di Nomina
                  <span class="text-red-500" aria-hidden="true">*</span></label
                >

                @if (isEditModeTemplates()) {
                  @if (!selectedAttoNominaTemplate()) {
                    <!-- Pulsante per aprire il dialog se non c'è selezione -->
                    <p-button
                      label="Seleziona dal Registro Template"
                      icon="pi pi-search"
                      [outlined]="true"
                      styleClass="w-full justify-content-center"
                      (onClick)="openTemplateAttoNominaDialog()" [attr.aria-label]="'Seleziona template atto di nomina dal registro'"
                      title="Seleziona template atto di nomina dal registro"
                    ></p-button>
                    <small class="text-muted block mt-2">
                      <i class="pi pi-info-circle mr-1" aria-hidden="true"></i>
                      Seleziona un template atto di nomina dal registro
                    </small>
                  } @else {
                    <!-- Card del template selezionato -->
                    <div class="surface-100 border-round p-4 border-1 border-300">
                      <div class="flex justify-content-between align-items-start">
                        <div class="flex-1">
                          <div class="flex align-items-center gap-2 mb-2">
                            <i
                              class="pi pi-file text-xl"
                              style="color: #00125b"
                              aria-hidden="true"
                            ></i>
                            <h4 class="text-lg font-semibold m-0">
                              {{ selectedAttoNominaTemplate()!.label }}
                            </h4>
                          </div>
                        </div>
                        <div class="flex gap-2">
                          <p-button
                            icon="pi pi-pencil"
                            [text]="true"
                            [rounded]="true"
                            severity="secondary"
                            pTooltip="Cambia template"
                            tooltipPosition="top"
                            (onClick)="openTemplateAttoNominaDialog()" [attr.aria-label]="'Cambia template atto di nomina selezionato'"
                            title="Cambia template atto di nomina selezionato"
                          ></p-button>
                          <p-button
                            icon="pi pi-times"
                            [text]="true"
                            [rounded]="true"
                            severity="danger"
                            pTooltip="Rimuovi selezione"
                            tooltipPosition="top"
                            (onClick)="clearTemplateAttoNomina()" [attr.aria-label]="'Rimuovi template atto di nomina selezionato'"
                            title="Rimuovi template atto di nomina selezionato"
                          ></p-button>
                        </div>
                      </div>
                    </div>
                  }
                } @else {
                  <!-- View mode -->
                  @if (selectedAttoNominaTemplate()) {
                    <div class="surface-100 border-round p-4 border-1 border-200">
                      <div class="flex align-items-center gap-2">
                        <i class="pi pi-file text-xl" style="color: #00125b" aria-hidden="true"></i>
                        <span class="font-semibold">{{ selectedAttoNominaTemplate()!.label }}</span>
                      </div>
                    </div>
                  } @else {
                    <div class="text-muted">Non selezionato</div>
                  }
                }
              </div>
            </div>
          }
        </div>

        @if (!isEditModeTemplates()) {
          <!-- Pulsante Genera Documento -->
          <div class="mt-4 flex justify-content-center">
            <p-button
              label="Genera Documento"
              icon="pi pi-file-word"
              size="large"
              [loading]="isRegeneratingDocument()"
              [disabled]="!canRegenerateContract() || isRegeneratingDocument()"
              [ariaLabel]="regenerateContractTooltip()"
              [pTooltip]="regenerateContractTooltip()"
              tooltipPosition="top"
              styleClass="p-button-success"
              (onClick)="regenerateContract()"
            ></p-button>
          </div>

          <div class="mt-3 p-3 bg-blue-50 border-1 border-blue-200 border-round">
            <div class="flex align-items-start gap-2">
              <i class="pi pi-info-circle text-blue-600 mt-1" aria-hidden="true"></i>
              <div class="text-sm text-blue-900">
                <p class="m-0 mb-2 font-semibold">Come funziona la generazione documento</p>
                <p class="m-0">
                  Usa il pulsante "Genera Documento" per creare il documento del contratto
                  utilizzando i template selezionati. Se vuoi utilizzare template diversi, clicca su
                  "Modifica" per cambiarli prima di generare il documento.
                </p>
              </div>
            </div>
          </div>
        }

        <!-- Footer con bottoni edit/save -->
        <div class="flex justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
          @if (isEditModeTemplates()) {
            <p-button
              label="Annulla"
              icon="pi pi-times"
              severity="secondary"
              [outlined]="true"
              (onClick)="toggleEditTemplates()" [attr.aria-label]="'Annulla modifiche template'"
              pTooltip="Annulla modifiche"
              tooltipPosition="top"
              title="Annulla modifiche"
            ></p-button>
            <p-button
              label="Salva"
              icon="pi pi-check"
              (onClick)="saveTemplates()" [attr.aria-label]="'Salva modifiche template'"
              pTooltip="Salva modifiche"
              tooltipPosition="top"
              title="Salva modifiche"
            ></p-button>
          } @else {
            <p-button
              label="Modifica"
              icon="pi pi-pencil"
              [outlined]="true"
              [disabled]="hasAnySectionInEditMode()"
              (onClick)="toggleEditTemplates()"
              [ariaLabel]="
                hasAnySectionInEditMode()
                  ? 'Modifica template - disabilitato: completa o annulla le modifiche alla sezione corrente'
                  : 'Modifica template'
              "
              [pTooltip]="
                hasAnySectionInEditMode()
                  ? 'Completa o annulla le modifiche alla sezione corrente prima di modificarne altre'
                  : 'Modifica template'
              "
              tooltipPosition="top"
            ></p-button>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: WORKFLOW CONTRATTO SUPPLIER ================= -->
    @if (!isContractProfessional() && contract()?.generalInfo?.status === 'GENERATED') {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-2"
        role="region"
        aria-labelledby="supplier-workflow-heading"
        style="border: 2px solid #00875a"
      >
        <div class="flex align-items-start gap-3 mb-4">
          <i class="pi pi-file-check text-4xl" style="color: #00875a" aria-hidden="true"></i>
          <div class="flex-1">
            <h2
              id="supplier-workflow-heading"
              class="text-2xl font-bold m-0 mb-2"
              style="color: #00875a"
            >
              Workflow Attivazione Contratto
            </h2>
            <p class="m-0 text-700 mb-2">
              Processo di attivazione per contratti fornitori
            </p>
          </div>
          <app-section-collapse-toggle sectionName="Workflow Attivazione Contratto"></app-section-collapse-toggle>
        </div>

        <div class="flex flex-column gap-4">
          <!-- STEP UNICO: Carica e Attiva Contratto -->
          <div
            class="border-1 border-round p-4"
            [class.border-orange-300]="!mainDocumentUrl()"
            [class.bg-orange-50]="!mainDocumentUrl()"
            [class.border-green-300]="!!mainDocumentUrl()"
            [class.bg-green-50]="!!mainDocumentUrl()"
          >
            <div class="flex align-items-start gap-3">
              <div class="flex-shrink-0">
                <span
                  class="flex align-items-center justify-content-center w-3rem h-3rem border-circle font-bold text-white"
                  [style.background-color]="mainDocumentUrl() ? '#00875a' : '#6b7280'"
                >
                  @if (mainDocumentUrl()) {
                    <i class="pi pi-check text-xl" aria-hidden="true"></i>
                  } @else {
                    <i class="pi pi-file-edit text-xl" aria-hidden="true"></i>
                  }
                </span>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-semibold m-0 mb-2">Carica Documento e Attiva Contratto</h3>
                
                @if (!mainDocumentUrl()) {
                  <p class="m-0 text-600 mb-3">
                    Carica il documento principale firmato del contratto per poterlo attivare.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-orange-50 border-1 border-orange-200 border-round mb-3">
                    <i class="pi pi-exclamation-circle text-orange-600" aria-hidden="true"></i>
                    <span class="text-sm text-orange-900 font-semibold">
                      In attesa del caricamento del documento firmato
                    </span>
                  </div>
                  
                  <!-- Box upload integrato -->
                  <div class="form-grid">
                    <div class="item full-width">
                      <label for="main-document-upload-supplier" class="block mb-2 font-semibold">
                        Carica Documento Firmato
                        <span class="text-sm font-normal text-600 ml-2">(PDF, DOC, DOCX - Max 10MB)</span>
                      </label>
                      <p-fileupload
                        #mainDocUpload
                        name="mainDocument"
                        [auto]="true"
                        [customUpload]="true"
                        (uploadHandler)="onMainDocumentSelect($event)"
                        accept=".pdf,.doc,.docx"
                        [maxFileSize]="10485760"
                        [disabled]="isUploadingMainDocument()"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        styleClass="custom-fileupload"
                        [attr.aria-label]="'Carica documento firmato del contratto'"
                        class="w-full"
                      >
                        <ng-template pTemplate="header">
                          <!-- Header vuoto -->
                        </ng-template>
                        <ng-template pTemplate="content" let-files let-chooseCallback="chooseCallback" let-removeFileCallback="removeFileCallback">
                          @if (isUploadingMainDocument()) {
                            <div class="flex align-items-center justify-content-center gap-2 p-5">
                              <i class="pi pi-spin pi-spinner text-2xl" aria-hidden="true"></i>
                              <span class="font-semibold">Caricamento in corso...</span>
                            </div>
                          } @else if (uploadErroredMainDoc()) {
                            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
                              <i class="pi pi-exclamation-triangle text-6xl mb-3 text-red-500" aria-hidden="true"></i>
                              <p class="m-0 mb-2 font-semibold text-900">Caricamento Fallito</p>
                              <p class="m-0 mb-3 text-sm text-600">Si è verificato un errore durante il caricamento</p>
                              <p-button label="Riprova" icon="pi pi-refresh" (onClick)="retryMainDocumentUpload()" severity="warn" [outlined]="true"></p-button>
                            </div>
                          } @else if (files && files.length === 0) {
                            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
                              <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
                              <p class="m-0 mb-2 font-semibold text-900">Trascina qui il documento firmato</p>
                              <p class="m-0 mb-3 text-sm text-600">oppure</p>
                              <p-button label="Scegli File" icon="pi pi-folder-open" (onClick)="chooseCallback()" [outlined]="true"></p-button>
                            </div>
                          } @else {
                            <div class="p-3">
                              @for (file of files; track file.name) {
                                <div class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round">
                                  <div class="flex align-items-center gap-3">
                                    <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
                                    <div>
                                      <div class="font-semibold">{{ file.name }}</div>
                                      <small class="text-600">{{ formatFileSize(file.size) }}</small>
                                    </div>
                                  </div>
                                  <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (onClick)="removeFileCallback(file)"></p-button>
                                </div>
                              }
                            </div>
                          }
                        </ng-template>
                      </p-fileupload>
                    </div>
                  </div>
                } @else {
                  <p class="m-0 text-600 mb-3">
                    Il documento è stato caricato. Attiva il contratto per renderlo operativo.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-green-50 border-1 border-green-200 border-round mb-3">
                    <i class="pi pi-check-circle text-green-600" aria-hidden="true"></i>
                    <span class="text-sm text-green-900 font-semibold">
                      Pronto per l'attivazione
                    </span>
                  </div>
                  
                  <p-button
                    label="Attiva Contratto"
                    icon="pi pi-bolt"
                    severity="success"
                    size="large"
                    (onClick)="activateContract()"
                    [ariaLabel]="activateContractTooltip()"
                    [pTooltip]="activateContractTooltip()"
                    tooltipPosition="top"
                  ></p-button>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    }

    <!-- ================= SECTION: WORKFLOW FIRMA PROFESSIONALE ================= -->
    @if (isContractProfessional() && contract()?.generalInfo?.status === 'GENERATED') {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-2"
        role="region"
        aria-labelledby="professional-workflow-heading"
        style="border: 2px solid #0052cc"
      >
        <div class="flex align-items-start gap-3 mb-4">
          <i class="pi pi-file-edit text-4xl" style="color: #0052cc" aria-hidden="true"></i>
          <div class="flex-1">
            <h2
              id="professional-workflow-heading"
              class="text-2xl font-bold m-0 mb-2"
              style="color: #0052cc"
            >
              Workflow Firma Bidirezionale
            </h2>
            <p class="m-0 text-700 mb-2">
              Processo di firma per contratti professionali: fiduciario + controfirma AXA
            </p>
            @if ((professionalStep() ?? 0) >= 2) {
              <div
                class="flex align-items-center gap-2 p-3 bg-blue-50 border-1 border-blue-200 border-round mt-3"
              >
                <i class="pi pi-info-circle text-blue-600" aria-hidden="true"></i>
                <span class="text-sm text-blue-900 font-semibold">
                  Il contratto è in workflow di firma. Non è possibile modificare dati o documenti.
                </span>
              </div>
            }
          </div>
          <app-section-collapse-toggle sectionName="Workflow Firma Bidirezionale"></app-section-collapse-toggle>
        </div>

        <div class="flex flex-column gap-4">
          <!-- STEP 1: Caricamento documento -->
          <div
            class="border-1 border-round p-4"
            [class.border-green-300]="(professionalStep() ?? 0) >= 2 || !!mainDocumentUrl()"
            [class.bg-green-50]="(professionalStep() ?? 0) >= 2"
            [class.border-200]="(professionalStep() ?? 0) < 2 && !mainDocumentUrl()"
          >
            <div class="flex align-items-start gap-3">
              <div class="flex-shrink-0">
                <span
                  class="flex align-items-center justify-content-center w-3rem h-3rem border-circle font-bold text-white"
                  [style.background-color]="(professionalStep() ?? 0) >= 2 ? '#00875a' : (mainDocumentUrl() ? '#0052cc' : '#6b7280')"
                >
                  @if ((professionalStep() ?? 0) >= 2) {
                    <i class="pi pi-check text-xl" aria-hidden="true"></i>
                  } @else {
                    1
                  }
                </span>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-semibold m-0 mb-2">Carica Documento da Firmare</h3>
                
                @if ((professionalStep() ?? 0) >= 2) {
                  <p class="m-0 text-600">
                    Documento caricato e inviato al fiduciario con successo.
                  </p>
                } @else if (!mainDocumentUrl()) {
                  <p class="m-0 text-600 mb-3">
                    Carica il documento del contratto da firmare prima di inviarlo al fiduciario.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-orange-50 border-1 border-orange-200 border-round mb-3">
                    <i class="pi pi-exclamation-triangle text-orange-600" aria-hidden="true"></i>
                    <span class="text-sm text-orange-900 font-semibold">
                      Documento non ancora caricato
                    </span>
                  </div>
                  
                  <!-- Box upload integrato -->
                  <div class="form-grid">
                    <div class="item full-width">
                      <label for="main-document-upload-step1" class="block mb-2 font-semibold">
                        Carica Documento Principale
                        <span class="text-sm font-normal text-600 ml-2">(PDF - Max 10MB)</span>
                      </label>
                      <p-fileupload
                        #mainDocUpload
                        name="mainDocument"
                        [auto]="true"
                        [customUpload]="true"
                        (uploadHandler)="onMainDocumentSelect($event)"
                        accept=".pdf"
                        [maxFileSize]="10485760"
                        [disabled]="isUploadingMainDocument()"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        styleClass="custom-fileupload"
                        class="w-full"
                      >
                        <ng-template pTemplate="header"></ng-template>
                        <ng-template pTemplate="content" let-files let-chooseCallback="chooseCallback" let-removeFileCallback="removeFileCallback">
                          @if (isUploadingMainDocument()) {
                            <div class="flex align-items-center justify-content-center gap-2 p-5">
                              <i class="pi pi-spin pi-spinner text-2xl" aria-hidden="true"></i>
                              <span class="font-semibold">Caricamento in corso...</span>
                            </div>
                          } @else if (uploadErroredMainDoc()) {
                            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
                              <i class="pi pi-exclamation-triangle text-6xl mb-3 text-red-500" aria-hidden="true"></i>
                              <p class="m-0 mb-2 font-semibold text-900">Caricamento Fallito</p>
                              <p class="m-0 mb-3 text-sm text-600">Si è verificato un errore</p>
                              <p-button label="Riprova" icon="pi pi-refresh" (onClick)="retryMainDocumentUpload()" severity="warn" [outlined]="true"></p-button>
                            </div>
                          } @else if (files && files.length === 0) {
                            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
                              <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
                              <p class="m-0 mb-2 font-semibold text-900">Trascina qui il documento</p>
                              <p class="m-0 mb-3 text-sm text-600">oppure</p>
                              <p-button label="Scegli File" icon="pi pi-folder-open" (onClick)="chooseCallback()" [outlined]="true"></p-button>
                            </div>
                          } @else {
                            <div class="p-3">
                              @for (file of files; track file.name) {
                                <div class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round">
                                  <div class="flex align-items-center gap-3">
                                    <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
                                    <div>
                                      <div class="font-semibold">{{ file.name }}</div>
                                      <small class="text-600">{{ formatFileSize(file.size) }}</small>
                                    </div>
                                  </div>
                                  <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (onClick)="removeFileCallback(file)"></p-button>
                                </div>
                              }
                            </div>
                          }
                        </ng-template>
                      </p-fileupload>
                    </div>
                  </div>
                } @else {
                  <p class="m-0 text-600 mb-3">
                    Documento caricato. Pronto per l'inv io al fiduciario.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-green-50 border-1 border-green-200 border-round mb-3">
                    <i class="pi pi-check-circle text-green-600" aria-hidden="true"></i>
                    <span class="text-sm text-green-900 font-semibold">
                      Documento caricato con successo
                    </span>
                  </div>
                  
                  <p-button
                    label="Invia al Fiduciario"
                    icon="pi pi-send"
                    severity="primary"
                    (onClick)="sendToFiduciaryForSignature()"
                    pTooltip="Invia il contratto al fiduciario per la firma"
                    tooltipPosition="top"
                  ></p-button>
                }
              </div>
            </div>
          </div>

          <!-- STEP 2: In attesa firma fiduciario -->
          <div
            class="border-1 border-round p-4"
            [class.border-orange-300]="(professionalStep() ?? 0) === 2"
            [class.bg-orange-50]="(professionalStep() ?? 0) === 2"
            [class.border-green-300]="(professionalStep() ?? 0) > 2"
            [class.bg-green-50]="(professionalStep() ?? 0) > 2"
            [class.border-gray-200]="(professionalStep() ?? 0) < 2"
            [class.bg-gray-50]="(professionalStep() ?? 0) < 2"
          >
            <div class="flex align-items-start gap-3">
              <div class="flex-shrink-0">
                <span
                  class="flex align-items-center justify-content-center w-3rem h-3rem border-circle font-bold text-white"
                  [style.background-color]="(professionalStep() ?? 0) > 2 ? '#00875a' : ((professionalStep() ?? 0) === 2 ? '#ff9800' : '#9ca3af')"
                >
                  @if ((professionalStep() ?? 0) > 2) {
                    <i class="pi pi-check text-xl" aria-hidden="true"></i>
                  } @else {
                    2
                  }
                </span>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-semibold m-0 mb-2">In Attesa Firma Fiduciario</h3>
                
                @if ((professionalStep() ?? 0) > 2) {
                  <p class="m-0 text-600">
                    Il fiduciario ha firmato il documento.
                  </p>
                } @else if ((professionalStep() ?? 0) === 2) {
                  <p class="m-0 text-600 mb-3">
                    Il contratto è stato inviato al fiduciario. In attesa che il fiduciario scarichi, firmi e ricarichi il documento.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-orange-50 border-1 border-orange-300 border-round mb-3">
                    <i class="pi pi-clock text-orange-700" aria-hidden="true"></i>
                    <span class="text-sm text-orange-900 font-semibold">
                      Processo in corso. Il sistema si aggiornerà automaticamente quando il fiduciario avrà firmato.
                    </span>
                  </div>
                  
                  <div class="flex gap-2 flex-wrap">
                    <p-button
                      label="Scarica Documento"
                      icon="pi pi-download"
                      severity="secondary"
                      [outlined]="true"
                      size="small"
                      (onClick)="downloadMainDocument()"
                      pTooltip="Scarica il documento inviato al fiduciario"
                      tooltipPosition="top"
                    ></p-button>
                    <!-- Upload manuale email/PEC temporaneamente rimosso: il caricamento non fa
                         avanzare lo step del fiduciario (gap da gestire lato BE). -->
                  </div>
                } @else {
                  <p class="m-0 text-600">
                    Completa gli step precedenti per procedere.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-gray-50 border-1 border-gray-200 border-round">
                    <i class="pi pi-lock text-gray-500" aria-hidden="true"></i>
                    <span class="text-sm text-gray-700 font-semibold">
                      In attesa del completamento degli step precedenti
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- STEP 3: Controfirma documento -->
          <div
            class="border-1 border-round p-4"
            [class.border-blue-300]="(professionalStep() ?? 0) === 3 && !mainDocumentUrl()"
            [class.bg-blue-50]="(professionalStep() ?? 0) === 3 && !mainDocumentUrl()"
            [class.border-green-300]="(professionalStep() ?? 0) >= 4 || ((professionalStep() ?? 0) === 3 && mainDocumentUrl())"
            [class.bg-green-50]="(professionalStep() ?? 0) >= 4"
            [class.border-gray-200]="(professionalStep() ?? 0) < 3"
            [class.bg-gray-50]="(professionalStep() ?? 0) < 3"
          >
            <div class="flex align-items-start gap-3">
              <div class="flex-shrink-0">
                <span
                  class="flex align-items-center justify-content-center w-3rem h-3rem border-circle font-bold text-white"
                  [style.background-color]="(professionalStep() ?? 0) >= 4 ? '#00875a' : ((professionalStep() ?? 0) === 3 ? '#0052cc' : '#9ca3af')"
                >
                  @if ((professionalStep() ?? 0) >= 4) {
                    <i class="pi pi-check text-xl" aria-hidden="true"></i>
                  } @else {
                    3
                  }
                </span>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-semibold m-0 mb-2">Controfirma Documento</h3>
                
                @if ((professionalStep() ?? 0) >= 4) {
                  <p class="m-0 text-600">
                    Documento controfirmato e caricato.
                  </p>
                } @else if ((professionalStep() ?? 0) === 3) {
                  <p class="m-0 text-600 mb-3">
                    Il fiduciario ha firmato il contratto. Scarica il documento firmato, controfirmalo e ricaricalo.
                  </p>

                  <div class="flex align-items-center gap-2 p-3 bg-green-50 border-1 border-green-200 border-round mb-3">
                    <i class="pi pi-check-circle text-green-600" aria-hidden="true"></i>
                    <span class="text-sm text-green-900 font-semibold">
                      Documento firmato dal fiduciario disponibile per il download
                    </span>
                  </div>

                  <div class="flex align-items-center gap-2 mb-3">
                    <p-button
                      label="Scarica Firmato dal Fiduciario"
                      icon="pi pi-download"
                      severity="secondary"
                      (onClick)="downloadSignedByFiduciary()"
                      pTooltip="Scarica il documento firmato dal fiduciario per controfirmarlo"
                      tooltipPosition="top"
                    ></p-button>
                    @if (canActivateProfessionalContract()) {
                      <p-button
                        label="Sostituisci Documento Controfirmato"
                        icon="pi pi-refresh"
                        severity="secondary"
                        (onClick)="startReplaceCountersignedDoc()"
                        pTooltip="Carica un nuovo documento controfirmato in sostituzione di quello precedente"
                        tooltipPosition="top"
                        [attr.aria-label]="'Sostituisci il documento controfirmato con uno nuovo'"
                      ></p-button>
                    }
                  </div>

                  @if (isReplacingFinalDoc()) {
                    <div class="flex align-items-center gap-2 p-3 bg-yellow-50 border-1 border-yellow-300 border-round mb-3">
                      <i class="pi pi-exclamation-triangle text-yellow-600" aria-hidden="true"></i>
                      <span class="text-sm text-yellow-900 font-semibold">
                        Carica il nuovo documento controfirmato per sostituire quello precedente
                      </span>
                    </div>
                    <div class="form-grid">
                      <div class="item full-width">
                        <p-fileupload
                          #mainDocUpload
                          name="mainDocument"
                          [auto]="true"
                          [customUpload]="true"
                          (uploadHandler)="onMainDocumentSelect($event)"
                          accept=".pdf"
                          [maxFileSize]="10485760"
                          [disabled]="isUploadingMainDocument()"
                          [showUploadButton]="false"
                          [showCancelButton]="false"
                          styleClass="custom-fileupload"
                          class="w-full"
                        >
                          <ng-template pTemplate="header"></ng-template>
                          <ng-template pTemplate="content" let-files let-chooseCallback="chooseCallback" let-removeFileCallback="removeFileCallback">
                            @if (isUploadingMainDocument()) {
                              <div class="flex align-items-center justify-content-center gap-2 p-5">
                                <i class="pi pi-spin pi-spinner text-2xl" aria-hidden="true"></i>
                                <span class="font-semibold">Caricamento in corso...</span>
                              </div>
                            } @else if (files && files.length === 0) {
                              <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
                                <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
                                <p class="m-0 mb-2 font-semibold text-900">Trascina qui il nuovo documento controfirmato</p>
                                <p class="m-0 mb-3 text-sm text-600">oppure</p>
                                <p-button label="Scegli File" icon="pi pi-folder-open" (onClick)="chooseCallback()" [outlined]="true"></p-button>
                              </div>
                            } @else {
                              <div class="p-3">
                                @for (file of files; track file.name) {
                                  <div class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round">
                                    <div class="flex align-items-center gap-3">
                                      <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
                                      <div>
                                        <div class="font-semibold">{{ file.name }}</div>
                                        <small class="text-600">{{ formatFileSize(file.size) }}</small>
                                      </div>
                                    </div>
                                    <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (onClick)="removeFileCallback(file)"></p-button>
                                  </div>
                                }
                              </div>
                            }
                          </ng-template>
                        </p-fileupload>
                      </div>
                    </div>
                  }
                } @else {
                  <p class="m-0 text-600">
                    Completa gli step precedenti per procedere.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-gray-50 border-1 border-gray-200 border-round">
                    <i class="pi pi-lock text-gray-500" aria-hidden="true"></i>
                    <span class="text-sm text-gray-700 font-semibold">
                      In attesa del completamento degli step precedenti
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- STEP 4: Attivazione finale -->
          <div
            class="border-1 border-round p-4"
            [class.border-orange-300]="(professionalStep() ?? 0) === 3 && !canActivateProfessionalContract()"
            [class.bg-orange-50]="(professionalStep() ?? 0) === 3 && !canActivateProfessionalContract()"
            [class.border-green-300]="canActivateProfessionalContract() || (professionalStep() ?? 0) >= 4"
            [class.bg-green-50]="canActivateProfessionalContract() || (professionalStep() ?? 0) >= 4"
            [class.border-gray-200]="(professionalStep() ?? 0) < 3"
            [class.bg-gray-50]="(professionalStep() ?? 0) < 3"
          >
            <div class="flex align-items-start gap-3">
              <div class="flex-shrink-0">
                <span
                  class="flex align-items-center justify-content-center w-3rem h-3rem border-circle font-bold text-white"
                  [style.background-color]="(professionalStep() ?? 0) >= 4 ? '#00875a' : ((professionalStep() ?? 0) === 3 ? (canActivateProfessionalContract() ? '#00875a' : '#6b7280') : '#9ca3af')"
                >
                  @if ((professionalStep() ?? 0) >= 4) {
                    <i class="pi pi-check text-xl" aria-hidden="true"></i>
                  } @else {
                    4
                  }
                </span>
              </div>
              <div class="flex-1">
                <h3 class="text-lg font-semibold m-0 mb-2">Attiva Contratto Fiduciario</h3>
                
                @if ((professionalStep() ?? 0) >= 4) {
                  <p class="m-0 text-600">
                    Contratto attivato con successo.
                  </p>
                } @else if ((professionalStep() ?? 0) === 3 && canActivateProfessionalContract()) {
                  <p class="m-0 text-600 mb-3">
                    Il documento è stato controfirmato. Attiva il contratto per completare il processo.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-green-50 border-1 border-green-200 border-round mb-3">
                    <i class="pi pi-check-circle text-green-600" aria-hidden="true"></i>
                    <span class="text-sm text-green-900 font-semibold">
                      Pronto per l'attivazione
                    </span>
                  </div>
                  
                  <p-button
                    label="Attiva Contratto Fiduciario"
                    icon="pi pi-bolt"
                    severity="success"
                    size="large"
                    (onClick)="activateProfessionalContract()"
                    pTooltip="Completa il processo e attiva il contratto fiduciario"
                    tooltipPosition="top"
                  ></p-button>
                } @else if ((professionalStep() ?? 0) === 3) {
                  <p class="m-0 text-600 mb-3">
                    Carica qui sotto il documento dopo averlo controfirmato.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-orange-50 border-1 border-orange-200 border-round mb-3">
                    <i class="pi pi-exclamation-circle text-orange-600" aria-hidden="true"></i>
                    <span class="text-sm text-orange-900 font-semibold">
                      In attesa del caricamento del documento controfirmato
                    </span>
                  </div>
                  
                  <!-- Box upload integrato -->
                  <div class="form-grid">
                    <div class="item full-width">
                      <label for="main-document-upload-step4" class="block mb-2 font-semibold">
                        Carica Documento Controfirmato
                        <span class="text-sm font-normal text-600 ml-2">(PDF - Max 10MB)</span>
                      </label>
                      <p-fileupload
                        #mainDocUpload
                        name="mainDocument"
                        [auto]="true"
                        [customUpload]="true"
                        (uploadHandler)="onMainDocumentSelect($event)"
                        accept=".pdf"
                        [maxFileSize]="10485760"
                        [disabled]="isUploadingMainDocument()"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        styleClass="custom-fileupload"
                        class="w-full"
                      >
                        <ng-template pTemplate="header"></ng-template>
                        <ng-template pTemplate="content" let-files let-chooseCallback="chooseCallback" let-removeFileCallback="removeFileCallback">
                          @if (isUploadingMainDocument()) {
                            <div class="flex align-items-center justify-content-center gap-2 p-5">
                              <i class="pi pi-spin pi-spinner text-2xl" aria-hidden="true"></i>
                              <span class="font-semibold">Caricamento in corso...</span>
                            </div>
                          } @else if (uploadErroredMainDoc()) {
                            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
                              <i class="pi pi-exclamation-triangle text-6xl mb-3 text-red-500" aria-hidden="true"></i>
                              <p class="m-0 mb-2 font-semibold text-900">Caricamento Fallito</p>
                              <p class="m-0 mb-3 text-sm text-600">Si è verificato un errore</p>
                              <p-button label="Riprova" icon="pi pi-refresh" (onClick)="retryMainDocumentUpload()" severity="warn" [outlined]="true"></p-button>
                            </div>
                          } @else if (files && files.length === 0) {
                            <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
                              <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
                              <p class="m-0 mb-2 font-semibold text-900">Trascina qui il documento controfirmato</p>
                              <p class="m-0 mb-3 text-sm text-600">oppure</p>
                              <p-button label="Scegli File" icon="pi pi-folder-open" (onClick)="chooseCallback()" [outlined]="true"></p-button>
                            </div>
                          } @else {
                            <div class="p-3">
                              @for (file of files; track file.name) {
                                <div class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round">
                                  <div class="flex align-items-center gap-3">
                                    <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
                                    <div>
                                      <div class="font-semibold">{{ file.name }}</div>
                                      <small class="text-600">{{ formatFileSize(file.size) }}</small>
                                    </div>
                                  </div>
                                  <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (onClick)="removeFileCallback(file)"></p-button>
                                </div>
                              }
                            </div>
                          }
                        </ng-template>
                      </p-fileupload>
                    </div>
                  </div>
                } @else {
                  <p class="m-0 text-600">
                    Completa gli step precedenti per procedere.
                  </p>
                  
                  <div class="flex align-items-center gap-2 p-3 bg-gray-50 border-1 border-gray-200 border-round">
                    <i class="pi pi-lock text-gray-500" aria-hidden="true"></i>
                    <span class="text-sm text-gray-700 font-semibold">
                      In attesa del completamento degli step precedenti
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>

          <!-- Step 5: Contratto attivo -->
          @if (isProfessionalContractActive()) {
            <div class="border-1 border-green-300 border-round p-4 bg-green-50">
              <div class="flex align-items-start gap-3">
                <div class="flex-shrink-0">
                  <span
                    class="flex align-items-center justify-content-center w-3rem h-3rem border-circle font-bold text-white"
                    style="background-color: #00875a"
                  >
                    <i class="pi pi-check text-xl" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="flex-1">
                  <h3 class="text-lg font-semibold m-0 mb-2 text-green-900">Contratto Attivo</h3>
                  <p class="m-0 text-green-800">
                    Il processo di firma bidirezionale è completato. Il professional è attivo e operativo.
                  </p>
                </div>
              </div>
            </div>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: DOCUMENTI PRINCIPALI ================= -->
    @if (shouldShowDocumentsSection()) {
      <section
        appCollapsibleSection
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="main-documents-heading"
      >
        <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
          <i class="pi pi-file-pdf text-2xl" style="color: var(--axa-blue-500)" aria-hidden="true"></i>
          <h2 id="main-documents-heading" class="text-xl font-semibold m-0" style="color: var(--axa-blue-600)">
            Documenti Contratto Principale
          </h2>
          <app-section-collapse-toggle sectionName="Documenti Contratto Principale"></app-section-collapse-toggle>
        </div>
        
        <p class="text-600 mb-4">
          @if (isContractProfessional()) {
            Scarica le versioni del contratto nelle diverse fasi del processo di firma bidirezionale.
          } @else {
            Scarica il contratto principale firmato.
          }
        </p>

        <div class="flex flex-column gap-2">
          <!-- Documento Originale (UNSIGNED) - Solo per Professional -->
          @if (hasUnsignedDocument() && isContractProfessional()) {
            <div class="flex align-items-center justify-content-between p-3 border-1 border-round" 
                 style="background-color: var(--axa-coral-100); border-color: var(--axa-coral-100)">
              <div class="flex align-items-center gap-3">
                <i class="pi pi-file text-2xl" style="color: var(--axa-coral-500)" aria-hidden="true"></i>
                <div>
                  <div class="font-semibold" style="color: var(--axa-neutral-800)">Contratto Originale</div>
                  <small style="color: var(--axa-neutral-700)">Documento iniziale da firmare</small>
                </div>
              </div>
              <p-button
                label="Scarica"
                icon="pi pi-download"
                severity="warn"
                size="small"
                (onClick)="downloadUnsignedDocument()"
                pTooltip="Scarica documento originale"
                tooltipPosition="left"
              />
            </div>
          }
          
          <!-- Documento Firmato Professional (EXTERNALLY_SIGNED) - Solo per Professional -->
          @if (hasExternallySignedDocument() && isContractProfessional()) {
            <div class="flex align-items-center justify-content-between p-3 border-1 border-round" 
                 style="background-color: var(--axa-blue-50); border-color: var(--axa-blue-100)">
              <div class="flex align-items-center gap-3">
                <i class="pi pi-check-circle text-2xl" style="color: var(--axa-blue-500)" aria-hidden="true"></i>
                <div>
                  <div class="font-semibold" style="color: var(--axa-neutral-800)">Contratto Firmato dal Fiduciario</div>
                  <small style="color: var(--axa-neutral-700)">Documento firmato dal fiduciario</small>
                </div>
              </div>
              <p-button
                label="Scarica"
                icon="pi pi-download"
                severity="info"
                size="small"
                (onClick)="downloadExternallySignedDocument()"
                pTooltip="Scarica documento firmato dal fiduciario"
                tooltipPosition="left"
              />
            </div>
          }
          
          <!-- Documento Controfirmato/Finale (FINAL) -->
          @if (hasFinalDocument()) {
            <div class="flex align-items-center justify-content-between p-3 border-1 border-round"
                 style="background-color: var(--axa-teal-200); border-color: var(--axa-teal-200)">
              <div class="flex align-items-center gap-3">
                <i class="pi pi-verified text-2xl" style="color: var(--axa-teal-500)" aria-hidden="true"></i>
                <div>
                  @if (isContractProfessional()) {
                    <div class="font-semibold" style="color: var(--axa-neutral-800)">Contratto Controfirmato</div>
                    <small style="color: var(--axa-neutral-700)">Versione finale controfirmata da AXA</small>
                  } @else {
                    <div class="font-semibold" style="color: var(--axa-neutral-800)">Contratto Firmato</div>
                    <small style="color: var(--axa-neutral-700)">Documento contrattuale finale</small>
                  }
                </div>
              </div>
              <p-button
                label="Scarica"
                icon="pi pi-download"
                severity="success"
                size="small"
                (onClick)="downloadFinalDocument()"
                [pTooltip]="isContractProfessional() ? 'Scarica documento controfirmato' : 'Scarica contratto firmato'"
                tooltipPosition="left"
              />
            </div>
          }
        </div>
      </section>
    }

    <!-- ================= SECTION: DOCUMENTI CONTRATTUALI ================= -->
    <section
      appCollapsibleSection
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="documents-heading"
    >
      <!-- Header con titolo + azione "Aggiungi documento" (a destra) -->
      <div
        class="flex align-items-center justify-content-between gap-3 mb-4 pb-3 border-bottom-1 border-200"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-folder-open text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="documents-heading" class="text-xl font-semibold m-0">
            Documenti a Corredo <span class="text-600 font-normal">(Opzionale)</span>
          </h2>
          <p-tag
            [value]="
              documents().length + ' ' + (documents().length === 1 ? 'documento' : 'documenti')
            "
            severity="secondary"
          ></p-tag>
        </div>
        <div class="flex align-items-center gap-2">
          <p-button
            label="Aggiungi documento"
            icon="pi pi-upload"
            [outlined]="true"
            size="small"
            (onClick)="docMgr.openUploadDialog()"
            [attr.aria-label]="'Aggiungi documento a corredo'"
            pTooltip="Aggiungi un documento a corredo"
            tooltipPosition="top"
            title="Aggiungi un documento a corredo"
          ></p-button>
          <app-section-collapse-toggle sectionName="Documenti a Corredo"></app-section-collapse-toggle>
        </div>
      </div>

      <!-- Tabella + upload documenti (componente riutilizzabile) -->
      <app-documents-manager
        #docMgr
        [showHeader]="false"
        [documents]="contractDocItems()"
        [uploading]="isUploadingAttachment()"
        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
        formatsHint="PDF, Word (DOC/DOCX), Excel (XLS/XLSX), PowerPoint (PPT/PPTX)"
        maxSizeHint="10 MB"
        [maxFileSizeBytes]="10485760"
        emptyMessage="Nessun documento caricato"
        (upload)="onContractDocumentUpload($event)"
        (download)="onContractDocumentDownload($event)"
        (remove)="onContractDocumentRemove($event)"
      ></app-documents-manager>
    </section>

    <!-- ================= SECTION: GESTISCI CONTRATTO ================= -->
    @if (shouldShowActionsSection()) {
      <section
        appCollapsibleSection
        id="actions"
        class="surface-0 border-round p-5 mb-4 shadow-1"
        role="region"
        aria-labelledby="actions-heading"
      >
        <!-- Header con titolo -->
        <div
          class="flex align-items-center justify-content-between gap-3 mb-4 pb-3 border-bottom-1 border-200"
        >
          <div class="flex align-items-center gap-3">
            <i class="pi pi-cog text-2xl" style="color: #00125b" aria-hidden="true"></i>
            <h2 id="actions-heading" class="text-xl font-semibold m-0">Gestisci Contratto</h2>
            <p-tag
              [value]="
                contractActions().length +
                ' ' +
                (contractActions().length === 1 ? 'azione' : 'azioni')
              "
              severity="info"
            ></p-tag>
          </div>
          <div class="flex align-items-center gap-2">
            <p-button
              label="Nuova Azione"
              icon="pi pi-plus"
              size="small"
              (onClick)="openNewActionDialog()"
              [disabled]="!canCreateNewActions()"
              [ariaLabel]="newActionTooltip()"
              [pTooltip]="newActionTooltip()"
              [title]="newActionTooltip()"
              tooltipPosition="top"
            ></p-button>
            <app-section-collapse-toggle sectionName="Gestisci Contratto"></app-section-collapse-toggle>
          </div>
        </div>

        <!-- Descrizione -->
        <div class="mb-4 p-3 bg-blue-50 border-1 border-blue-200 border-round">
          <div class="flex align-items-start gap-2">
            <i class="pi pi-info-circle text-blue-600" aria-hidden="true"></i>
            <div class="text-sm text-blue-800">
              <p class="m-0 mb-2 font-semibold">Gestisci modifiche e integrazioni contrattuali</p>
              <p class="m-0">
                Da questa sezione puoi formalizzare modifiche alla durata, all'oggetto, ai
                corrispettivi, estendere le parti contrattuali, rinnovare o recedere dal contratto.
              </p>
            </div>
          </div>
        </div>

        <!-- Tabella Azioni -->
        <p-table
          [value]="contractActions()"
          [tableStyle]="{ 'min-width': '50rem' }"
          styleClass="p-datatable-sm"
          [paginator]="contractActions().length > 10"
          [rows]="10"
          responsiveLayout="scroll" [attr.aria-label]="'Tabella azioni contrattuali'"
        >
          <ng-template #header>
            <tr>
              <th style="width: 100px">ID Azione</th>
              <th>Nome Azione</th>
              <th style="width: 150px">Tipo Azione</th>
              <th style="width: 130px">Stato</th>
              <th style="width: 180px">Data Creazione</th>
              <th style="width: 180px">Azioni</th>
            </tr>
          </ng-template>
          <ng-template #body let-action>
            <tr>
              <td>
                <span class="font-semibold">#{{ action.id }}</span>
              </td>
              <td>
                <span class="font-semibold">{{ action.actionName }}</span>
              </td>
              <td>
                {{ getActionTypeLabel(action.actionType) }}
              </td>
              <td>
                <p-tag
                  [value]="getActionStatusLabel(action.status)"
                  [severity]="getActionStatusSeverity(action.status)"
                ></p-tag>
              </td>
              <td>
                {{ formatDate(action.createdAt) }}
              </td>
              <td>
                <div class="flex gap-2">
                  <p-button
                    icon="pi pi-eye"
                    [rounded]="true"
                    [text]="true"
                    size="small"
                    severity="info"
                    styleClass="detail-view-btn"
                    (onClick)="viewActionDetails(action)" [attr.aria-label]="'Visualizza dettagli azione'"
                    pTooltip="Visualizza dettagli"
                    tooltipPosition="top"
                    title="Visualizza dettagli"
                  ></p-button>
                  @if (action.selectedTemplateId) {
                    <p-button
                      icon="pi pi-file-word"
                      [rounded]="true"
                      [text]="true"
                      size="small"
                      severity="secondary"
                      (onClick)="generateActionDocument(action)" [attr.aria-label]="'Genera documento azione'"
                      pTooltip="Genera documento"
                      tooltipPosition="top"
                      title="Genera documento"
                    ></p-button>
                  }
                  @if (action.status === 'DRAFT') {
                    <p-button
                      icon="pi pi-trash"
                      [rounded]="true"
                      [text]="true"
                      size="small"
                      severity="danger"
                      (onClick)="deleteAction(action)" [attr.aria-label]="'Elimina azione'"
                      pTooltip="Elimina"
                      tooltipPosition="top"
                      title="Elimina"
                    ></p-button>
                  }
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="6" class="text-center p-4">
                <div class="flex align-items-center justify-content-center flex-column gap-3">
                  <i class="pi pi-inbox text-4xl text-400" aria-hidden="true"></i>
                  <p class="m-0 text-color-secondary">
                    Nessuna azione presente. Clicca su "Nuova Azione" per iniziare.
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </section>
    }
  } @else {
    <div
      class="flex align-items-center justify-content-center flex-column"
      style="min-height: 400px"
      role="status"
      aria-live="polite"
    >
      <i
        class="pi pi-exclamation-triangle text-6xl mb-4"
        style="color: #ffc107"
        aria-hidden="true"
      ></i>
      <h3 class="text-2xl font-semibold mb-2">Contratto non trovato</h3>
      <p class="text-color-secondary mb-4">
        Il contratto richiesto non è disponibile o non esiste.
      </p>
      <button
        pButton
        label="Torna al registro"
        icon="pi pi-arrow-left"
        (click)="goBack()"
        aria-label="Torna al registro contratti"
        title="Torna al registro contratti"
      ></button>
    </div>
  }
</div>

<!-- Dialog per selezione Responsabile -->
<p-dialog
  [(visible)]="showResponsibleDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [contentStyle]="{ padding: '0' }" [attr.aria-label]="'Dialog selezione responsabile'"
  aria-labelledby="responsible-dialog-title"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-user-edit text-xl" style="color: #00125b" aria-hidden="true"></i>
      <span id="responsible-dialog-title" class="text-xl font-semibold" style="color: #00125b"
        >Seleziona Responsabile dal Registro</span
      >
    </div>
  </ng-template>

  <div class="p-4" role="region" aria-labelledby="responsible-dialog-title">
    <app-registry-table
      [title]="''"
      [columns]="responsibleColumns"
      [data]="responsibleTableData()"
      [loading]="loadingResponsibles()"
      [showClearFiltersButton]="false"
      emptyStateMessage="Nessun responsabile trovato nel registro."
      (onSelectClick)="onResponsibleSelect($event)"
    />
  </div>
</p-dialog>

<!-- Dialog per selezione Sub-Responsabile -->
<p-dialog
  [(visible)]="showSubResponsibleDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [contentStyle]="{ padding: '0' }" [attr.aria-label]="'Dialog selezione sub-responsabile'"
  aria-labelledby="sub-responsible-dialog-title"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-sitemap text-xl" style="color: #00125b" aria-hidden="true"></i>
      <span id="sub-responsible-dialog-title" class="text-xl font-semibold" style="color: #00125b"
        >Seleziona Sub-Responsabile dal Registro</span
      >
    </div>
  </ng-template>

  <div class="p-4" role="region" aria-labelledby="sub-responsible-dialog-title">
    <app-registry-table
      [title]="''"
      [columns]="subResponsibleColumns"
      [data]="subResponsibleTableData()"
      [loading]="loadingSubResponsibles()"
      [showClearFiltersButton]="false"
      emptyStateMessage="Nessun sub-responsabile trovato nel registro."
      (onSelectClick)="onSubResponsibleSelect($event)"
    />
  </div>
</p-dialog>

<!-- Dialog per selezione Template Contratto -->
<p-dialog
  [(visible)]="showTemplateContrattoDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [contentStyle]="{ padding: '0' }" [attr.aria-label]="'Dialog selezione template contratto'"
  aria-labelledby="template-contratto-dialog-title"
  (onHide)="closeTemplateContrattoDialog()"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-file text-xl" style="color: #00125b" aria-hidden="true"></i>
        <span
          id="template-contratto-dialog-title"
          class="text-xl font-semibold"
          style="color: #00125b"
          >Seleziona Template Contratto</span
        >
      </div>
    </div>
  </ng-template>

  <div class="p-4" role="region" aria-labelledby="template-contratto-dialog-title">
    <app-registry-table
      [title]="''"
      [columns]="templateContrattoColumns"
      [data]="templateContrattoTableData()"
      [loading]="false"
      [showClearFiltersButton]="false"
      emptyStateMessage="Nessun template contratto disponibile."
      (onSelectClick)="selectTemplateContratto($event)"
    />
  </div>
</p-dialog>

<!-- Dialog per selezione Template Atto di Nomina -->
<p-dialog
  [(visible)]="showTemplateAttoNominaDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [contentStyle]="{ padding: '0' }" [attr.aria-label]="'Dialog selezione template atto di nomina'"
  aria-labelledby="template-atto-dialog-title"
  (onHide)="closeTemplateAttoNominaDialog()"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-file text-xl" style="color: #00125b" aria-hidden="true"></i>
        <span id="template-atto-dialog-title" class="text-xl font-semibold" style="color: #00125b"
          >Seleziona Template Atto di Nomina</span
        >
      </div>
    </div>
  </ng-template>

  <div class="p-4" role="region" aria-labelledby="template-atto-dialog-title">
    <app-registry-table
      [title]="''"
      [columns]="templateAttoNominaColumns"
      [data]="templateAttoNominaTableData()"
      [loading]="false"
      [showClearFiltersButton]="false"
      emptyStateMessage="Nessun template atto di nomina disponibile."
      (onSelectClick)="selectTemplateAttoNomina($event)"
    />
  </div>
</p-dialog>
